import { useState, useEffect, useRef } from "react";

const AGE_GROUPS = [
  "Under 25",
  "25-29",
  "30-34",
  "35-39",
  "40-44",
  "45-49",
  "50-54",
  "55-59",
  "60+",
];

const PUSHUP_SCORES = {
  "Under 25": {
    M: [
      [15, 67],
      [14.5, 66],
      [14, 64],
      [13.5, 63],
      [13, 61],
      [12.5, 60],
      [12, 58],
      [11.5, 57],
      [11, 55],
      [10.5, 54],
      [10, 52],
      [9.5, 51],
      [9, 49],
      [8.5, 48],
      [8, 46],
      [7.5, 45],
      [7, 43],
      [6.5, 42],
      [6, 40],
      [5.5, 39],
      [5, 37],
      [4.5, 36],
      [4, 34],
      [3.5, 33],
      [3, 31],
      [2.5, 30],
    ],
    F: [
      [15, 50],
      [14.5, 49],
      [14, 47],
      [13.5, 46],
      [13, 44],
      [12.5, 43],
      [12, 42],
      [11.5, 40],
      [11, 39],
      [10.5, 37],
      [10, 36],
      [9.5, 35],
      [9, 33],
      [8.5, 32],
      [8, 30],
      [7.5, 29],
      [7, 28],
      [6.5, 26],
      [6, 25],
      [5.5, 23],
      [5, 22],
      [4.5, 21],
      [4, 19],
      [3.5, 18],
      [3, 16],
      [2.5, 15],
    ],
  },
  "25-29": {
    M: [
      [15, 63],
      [14.5, 62],
      [14, 60],
      [13.5, 59],
      [13, 57],
      [12.5, 56],
      [12, 55],
      [11.5, 53],
      [11, 52],
      [10.5, 50],
      [10, 49],
      [9.5, 48],
      [9, 46],
      [8.5, 45],
      [8, 43],
      [7.5, 42],
      [7, 41],
      [6.5, 39],
      [6, 38],
      [5.5, 36],
      [5, 35],
      [4.5, 34],
      [4, 32],
      [3.5, 31],
      [3, 29],
      [2.5, 28],
    ],
    F: [
      [15, 47],
      [14.5, 46],
      [14, 44],
      [13.5, 43],
      [13, 42],
      [12.5, 40],
      [12, 39],
      [11.5, 38],
      [11, 36],
      [10.5, 35],
      [10, 34],
      [9.5, 32],
      [9, 31],
      [8.5, 30],
      [8, 29],
      [7.5, 27],
      [7, 26],
      [6.5, 25],
      [6, 23],
      [5.5, 22],
      [5, 21],
      [4.5, 19],
      [4, 18],
      [3.5, 17],
      [3, 15],
      [2.5, 14],
    ],
  },
  "30-34": {
    M: [
      [15, 60],
      [14.5, 59],
      [14, 57],
      [13.5, 56],
      [13, 55],
      [12.5, 53],
      [12, 52],
      [11.5, 51],
      [11, 49],
      [10.5, 48],
      [10, 47],
      [9.5, 45],
      [9, 44],
      [8.5, 43],
      [8, 41],
      [7.5, 40],
      [7, 39],
      [6.5, 37],
      [6, 36],
      [5.5, 35],
      [5, 33],
      [4.5, 32],
      [4, 31],
      [3.5, 29],
      [3, 26],
      [2.5, 26],
    ],
    F: [
      [15, 44],
      [14.5, 42],
      [14, 41],
      [13.5, 40],
      [13, 39],
      [12.5, 37],
      [12, 36],
      [11.5, 35],
      [11, 34],
      [10.5, 32],
      [10, 31],
      [9.5, 30],
      [9, 29],
      [8.5, 27],
      [8, 26],
      [7.5, 25],
      [7, 24],
      [6.5, 22],
      [6, 21],
      [5.5, 20],
      [5, 19],
      [4.5, 17],
      [4, 16],
      [3.5, 15],
      [3, 14],
      [2.5, 12],
    ],
  },
  "35-39": {
    M: [
      [15, 56],
      [14.5, 55],
      [14, 53],
      [13.5, 52],
      [13, 51],
      [12.5, 49],
      [12, 48],
      [11.5, 47],
      [11, 45],
      [10.5, 44],
      [10, 43],
      [9.5, 41],
      [9, 40],
      [8.5, 39],
      [8, 38],
      [7.5, 36],
      [7, 35],
      [6.5, 34],
      [6, 32],
      [5.5, 31],
      [5, 30],
      [4.5, 28],
      [4, 27],
      [3.5, 26],
      [3, 24],
      [2.5, 23],
    ],
    F: [
      [15, 42],
      [14.5, 41],
      [14, 40],
      [13.5, 38],
      [13, 37],
      [12.5, 36],
      [12, 35],
      [11.5, 33],
      [11, 32],
      [10.5, 31],
      [10, 30],
      [9.5, 28],
      [9, 27],
      [8.5, 26],
      [8, 25],
      [7.5, 23],
      [7, 22],
      [6.5, 21],
      [6, 20],
      [5.5, 18],
      [5, 17],
      [4.5, 16],
      [4, 15],
      [3.5, 13],
      [3, 12],
      [2.5, 11],
    ],
  },
  "40-44": {
    M: [
      [15, 52],
      [14.5, 51],
      [14, 50],
      [13.5, 49],
      [13, 48],
      [12.5, 46],
      [12, 45],
      [11.5, 44],
      [11, 42],
      [10.5, 41],
      [10, 40],
      [9.5, 39],
      [9, 37],
      [8.5, 36],
      [8, 35],
      [7.5, 33],
      [7, 32],
      [6.5, 31],
      [6, 30],
      [5.5, 28],
      [5, 27],
      [4.5, 26],
      [4, 24],
      [3.5, 23],
      [3, 22],
      [2.5, 21],
    ],
    F: [
      [15, 39],
      [14.5, 38],
      [14, 37],
      [13.5, 36],
      [13, 35],
      [12.5, 33],
      [12, 32],
      [11.5, 31],
      [11, 30],
      [10.5, 29],
      [10, 27],
      [9.5, 26],
      [9, 25],
      [8.5, 24],
      [8, 23],
      [7.5, 21],
      [7, 20],
      [6.5, 19],
      [6, 18],
      [5.5, 17],
      [5, 15],
      [4.5, 14],
      [4, 13],
      [3.5, 12],
      [3, 11],
      [2.5, 10],
    ],
  },
  "45-49": {
    M: [
      [15, 49],
      [14.5, 47],
      [14, 46],
      [13.5, 45],
      [13, 44],
      [12.5, 43],
      [12, 42],
      [11.5, 40],
      [11, 39],
      [10.5, 38],
      [10, 37],
      [9.5, 36],
      [9, 35],
      [8.5, 33],
      [8, 32],
      [7.5, 31],
      [7, 30],
      [6.5, 29],
      [6, 28],
      [5.5, 26],
      [5, 25],
      [4.5, 24],
      [4, 23],
      [3.5, 22],
      [3, 21],
      [2.5, 19],
    ],
    F: [
      [15, 36],
      [14.5, 35],
      [14, 34],
      [13.5, 33],
      [13, 32],
      [12.5, 30],
      [12, 29],
      [11.5, 28],
      [11, 27],
      [10.5, 26],
      [10, 25],
      [9.5, 24],
      [9, 23],
      [8.5, 21],
      [8, 20],
      [7.5, 19],
      [7, 18],
      [6.5, 17],
      [6, 16],
      [5.5, 15],
      [5, 14],
      [4.5, 12],
      [4, 11],
      [3.5, 10],
      [3, 9],
      [2.5, 8],
    ],
  },
  "50-54": {
    M: [
      [15, 45],
      [14.5, 44],
      [14, 43],
      [13.5, 42],
      [13, 41],
      [12.5, 39],
      [12, 38],
      [11.5, 37],
      [11, 36],
      [10.5, 35],
      [10, 34],
      [9.5, 33],
      [9, 32],
      [8.5, 30],
      [8, 29],
      [7.5, 28],
      [7, 27],
      [6.5, 26],
      [6, 25],
      [5.5, 24],
      [5, 23],
      [4.5, 21],
      [4, 20],
      [3.5, 19],
      [3, 18],
      [2.5, 17],
    ],
    F: [
      [15, 34],
      [14.5, 33],
      [14, 32],
      [13.5, 31],
      [13, 30],
      [12.5, 29],
      [12, 28],
      [11.5, 26],
      [11, 25],
      [10.5, 24],
      [10, 23],
      [9.5, 22],
      [9, 21],
      [8.5, 20],
      [8, 19],
      [7.5, 18],
      [7, 17],
      [6.5, 16],
      [6, 15],
      [5.5, 13],
      [5, 12],
      [4.5, 11],
      [4, 10],
      [3.5, 9],
      [3, 8],
      [2.5, 7],
    ],
  },
  "55-59": {
    M: [
      [15, 42],
      [14.5, 41],
      [14, 40],
      [13.5, 39],
      [13, 38],
      [12.5, 36],
      [12, 35],
      [11.5, 34],
      [11, 33],
      [10.5, 32],
      [10, 31],
      [9.5, 30],
      [9, 29],
      [8.5, 27],
      [8, 26],
      [7.5, 25],
      [7, 24],
      [6.5, 23],
      [6, 22],
      [5.5, 21],
      [5, 20],
      [4.5, 18],
      [4, 17],
      [3.5, 16],
      [3, 15],
      [2.5, 14],
    ],
    F: [
      [15, 31],
      [14.5, 30],
      [14, 29],
      [13.5, 28],
      [13, 27],
      [12.5, 26],
      [12, 25],
      [11.5, 24],
      [11, 23],
      [10.5, 22],
      [10, 21],
      [9.5, 20],
      [9, 19],
      [8.5, 17],
      [8, 16],
      [7.5, 15],
      [7, 14],
      [6.5, 13],
      [6, 12],
      [5.5, 11],
      [5, 10],
      [4.5, 9],
      [4, 8],
      [3.5, 7],
      [3, 6],
      [2.5, 5],
    ],
  },
  "60+": {
    M: [
      [15, 38],
      [14.5, 37],
      [14, 36],
      [13.5, 35],
      [13, 34],
      [12.5, 33],
      [12, 32],
      [11.5, 31],
      [11, 30],
      [10.5, 29],
      [10, 28],
      [9.5, 27],
      [9, 26],
      [8.5, 24],
      [8, 23],
      [7.5, 22],
      [7, 21],
      [6.5, 20],
      [6, 19],
      [5.5, 18],
      [5, 17],
      [4.5, 16],
      [4, 15],
      [3.5, 14],
      [3, 13],
      [2.5, 12],
    ],
    F: [
      [15, 28],
      [14.5, 27],
      [14, 26],
      [13.5, 25],
      [13, 24],
      [12.5, 23],
      [12, 22],
      [11.5, 21],
      [11, 20],
      [10.5, 19],
      [10, 18],
      [9.5, 17],
      [9, 16],
      [8.5, 15],
      [8, 14],
      [7.5, 13],
      [7, 12],
      [6.5, 11],
      [6, 10],
      [5.5, 9],
      [5, 8],
      [4.5, 7],
      [4, 6],
      [3.5, 5],
      [3, 4],
      [2.5, 3],
    ],
  },
};

const HRPU_SCORES = {
  "Under 25": {
    M: [
      [15, 58],
      [14.5, 57],
      [14, 56],
      [13.5, 55],
      [13, 54],
      [12.5, 53],
      [12, 52],
      [11.5, 51],
      [11, 50],
      [10.5, 49],
      [10, 48],
      [9.5, 47],
      [9, 46],
      [8.5, 45],
      [8, 44],
      [7.5, 43],
      [7, 42],
      [6.5, 41],
      [6, 40],
      [5.5, 39],
      [5, 38],
      [4.5, 37],
      [4, 36],
      [3.5, 35],
      [3, 34],
      [2.5, 33],
    ],
    F: [
      [15, 54],
      [14.5, 53],
      [14, 52],
      [13.5, 51],
      [13, 50],
      [12.5, 49],
      [12, 48],
      [11.5, 47],
      [11, 46],
      [10.5, 45],
      [10, 44],
      [9.5, 43],
      [9, 42],
      [8.5, 41],
      [8, 40],
      [7.5, 39],
      [7, 38],
      [6.5, 37],
      [6, 36],
      [5.5, 35],
      [5, 34],
      [4.5, 33],
      [4, 32],
      [3.5, 31],
      [3, 30],
      [2.5, 29],
    ],
  },
  "25-29": {
    M: [
      [15, 56],
      [14.5, 55],
      [14, 54],
      [13.5, 53],
      [13, 52],
      [12.5, 51],
      [12, 50],
      [11.5, 49],
      [11, 48],
      [10.5, 47],
      [10, 46],
      [9.5, 45],
      [9, 44],
      [8.5, 43],
      [8, 42],
      [7.5, 41],
      [7, 40],
      [6.5, 39],
      [6, 38],
      [5.5, 37],
      [5, 36],
      [4.5, 35],
      [4, 34],
      [3.5, 33],
      [3, 32],
      [2.5, 31],
    ],
    F: [
      [15, 50],
      [14.5, 49],
      [14, 48],
      [13.5, 47],
      [13, 46],
      [12.5, 45],
      [12, 44],
      [11.5, 43],
      [11, 42],
      [10.5, 41],
      [10, 40],
      [9.5, 39],
      [9, 38],
      [8.5, 37],
      [8, 36],
      [7.5, 35],
      [7, 34],
      [6.5, 33],
      [6, 32],
      [5.5, 31],
      [5, 30],
      [4.5, 29],
      [4, 28],
      [3.5, 27],
      [3, 26],
      [2.5, 25],
    ],
  },
  "30-34": {
    M: [
      [15, 54],
      [14.5, 53],
      [14, 52],
      [13.5, 51],
      [13, 50],
      [12.5, 49],
      [12, 48],
      [11.5, 47],
      [11, 46],
      [10.5, 45],
      [10, 44],
      [9.5, 43],
      [9, 42],
      [8.5, 41],
      [8, 40],
      [7.5, 39],
      [7, 38],
      [6.5, 37],
      [6, 36],
      [5.5, 35],
      [5, 34],
      [4.5, 33],
      [4, 32],
      [3.5, 31],
      [3, 30],
      [2.5, 29],
    ],
    F: [
      [15, 45],
      [14.5, 44],
      [14, 43],
      [13.5, 42],
      [13, 41],
      [12.5, 40],
      [12, 39],
      [11.5, 38],
      [11, 37],
      [10.5, 36],
      [10, 35],
      [9.5, 34],
      [9, 33],
      [8.5, 32],
      [8, 31],
      [7.5, 30],
      [7, 29],
      [6.5, 28],
      [6, 27],
      [5.5, 26],
      [5, 25],
      [4.5, 24],
      [4, 23],
      [3.5, 22],
      [3, 21],
      [2.5, 20],
    ],
  },
  "35-39": {
    M: [
      [15, 52],
      [14.5, 51],
      [14, 50],
      [13.5, 49],
      [13, 48],
      [12.5, 47],
      [12, 46],
      [11.5, 45],
      [11, 44],
      [10.5, 43],
      [10, 42],
      [9.5, 41],
      [9, 40],
      [8.5, 39],
      [8, 38],
      [7.5, 37],
      [7, 36],
      [6.5, 35],
      [6, 34],
      [5.5, 33],
      [5, 32],
      [4.5, 31],
      [4, 30],
      [3.5, 29],
      [3, 28],
      [2.5, 27],
    ],
    F: [
      [15, 43],
      [14.5, 42],
      [14, 41],
      [13.5, 40],
      [13, 39],
      [12.5, 38],
      [12, 37],
      [11.5, 36],
      [11, 35],
      [10.5, 34],
      [10, 33],
      [9.5, 32],
      [9, 31],
      [8.5, 30],
      [8, 29],
      [7.5, 28],
      [7, 27],
      [6.5, 26],
      [6, 25],
      [5.5, 24],
      [5, 23],
      [4.5, 22],
      [4, 21],
      [3.5, 20],
      [3, 19],
      [2.5, 18],
    ],
  },
  "40-44": {
    M: [
      [15, 50],
      [14.5, 49],
      [14, 48],
      [13.5, 47],
      [13, 46],
      [12.5, 45],
      [12, 44],
      [11.5, 43],
      [11, 42],
      [10.5, 41],
      [10, 40],
      [9.5, 39],
      [9, 38],
      [8.5, 37],
      [8, 36],
      [7.5, 35],
      [7, 34],
      [6.5, 33],
      [6, 32],
      [5.5, 31],
      [5, 30],
      [4.5, 29],
      [4, 28],
      [3.5, 27],
      [3, 26],
      [2.5, 25],
    ],
    F: [
      [15, 41],
      [14.5, 40],
      [14, 39],
      [13.5, 38],
      [13, 37],
      [12.5, 36],
      [12, 35],
      [11.5, 34],
      [11, 33],
      [10.5, 32],
      [10, 31],
      [9.5, 30],
      [9, 29],
      [8.5, 28],
      [8, 27],
      [7.5, 26],
      [7, 25],
      [6.5, 24],
      [6, 23],
      [5.5, 22],
      [5, 21],
      [4.5, 20],
      [4, 19],
      [3.5, 18],
      [3, 17],
      [2.5, 16],
    ],
  },
  "45-49": {
    M: [
      [15, 48],
      [14.5, 47],
      [14, 46],
      [13.5, 45],
      [13, 44],
      [12.5, 43],
      [12, 42],
      [11.5, 41],
      [11, 40],
      [10.5, 39],
      [10, 38],
      [9.5, 37],
      [9, 36],
      [8.5, 35],
      [8, 34],
      [7.5, 33],
      [7, 32],
      [6.5, 31],
      [6, 30],
      [5.5, 29],
      [5, 28],
      [4.5, 27],
      [4, 26],
      [3.5, 25],
      [3, 24],
      [2.5, 23],
    ],
    F: [
      [15, 35],
      [14.5, 34],
      [14, 33],
      [13.5, 32],
      [13, 31],
      [12.5, 30],
      [12, 29],
      [11.5, 28],
      [11, 27],
      [10.5, 26],
      [10, 25],
      [9.5, 24],
      [9, 23],
      [8.5, 22],
      [8, 21],
      [7.5, 20],
      [7, 19],
      [6.5, 18],
      [6, 17],
      [5.5, 16],
      [5, 15],
      [4.5, 14],
      [4, 13],
      [3.5, 12],
      [3, 11],
      [2.5, 10],
    ],
  },
  "50-54": {
    M: [
      [15, 46],
      [14.5, 45],
      [14, 44],
      [13.5, 43],
      [13, 42],
      [12.5, 41],
      [12, 40],
      [11.5, 39],
      [11, 38],
      [10.5, 37],
      [10, 36],
      [9.5, 35],
      [9, 34],
      [8.5, 33],
      [8, 32],
      [7.5, 31],
      [7, 30],
      [6.5, 29],
      [6, 28],
      [5.5, 27],
      [5, 26],
      [4.5, 25],
      [4, 24],
      [3.5, 23],
      [3, 22],
      [2.5, 21],
    ],
    F: [
      [15, 34],
      [14.5, 33],
      [14, 32],
      [13.5, 31],
      [13, 30],
      [12.5, 29],
      [12, 28],
      [11.5, 27],
      [11, 26],
      [10.5, 25],
      [10, 24],
      [9.5, 23],
      [9, 22],
      [8.5, 21],
      [8, 20],
      [7.5, 19],
      [7, 18],
      [6.5, 17],
      [6, 16],
      [5.5, 15],
      [5, 14],
      [4.5, 13],
      [4, 12],
      [3.5, 11],
      [3, 10],
      [2.5, 9],
    ],
  },
  "55-59": {
    M: [
      [15, 44],
      [14.5, 43],
      [14, 42],
      [13.5, 41],
      [13, 40],
      [12.5, 39],
      [12, 38],
      [11.5, 37],
      [11, 36],
      [10.5, 35],
      [10, 34],
      [9.5, 33],
      [9, 32],
      [8.5, 31],
      [8, 30],
      [7.5, 29],
      [7, 28],
      [6.5, 27],
      [6, 26],
      [5.5, 25],
      [5, 24],
      [4.5, 23],
      [4, 22],
      [3.5, 21],
      [3, 20],
      [2.5, 19],
    ],
    F: [
      [15, 32],
      [14.5, 31],
      [14, 30],
      [13.5, 29],
      [13, 28],
      [12.5, 27],
      [12, 26],
      [11.5, 25],
      [11, 24],
      [10.5, 23],
      [10, 22],
      [9.5, 21],
      [9, 20],
      [8.5, 19],
      [8, 18],
      [7.5, 17],
      [7, 16],
      [6.5, 15],
      [6, 14],
      [5.5, 13],
      [5, 12],
      [4.5, 11],
      [4, 10],
      [3.5, 9],
      [3, 8],
      [2.5, 7],
    ],
  },
  "60+": {
    M: [
      [15, 42],
      [14.5, 41],
      [14, 40],
      [13.5, 39],
      [13, 38],
      [12.5, 37],
      [12, 36],
      [11.5, 35],
      [11, 34],
      [10.5, 33],
      [10, 32],
      [9.5, 31],
      [9, 30],
      [8.5, 29],
      [8, 28],
      [7.5, 27],
      [7, 26],
      [6.5, 25],
      [6, 24],
      [5.5, 23],
      [5, 22],
      [4.5, 21],
      [4, 20],
      [3.5, 19],
      [3, 18],
      [2.5, 17],
    ],
    F: [
      [15, 31],
      [14.5, 30],
      [14, 29],
      [13.5, 28],
      [13, 27],
      [12.5, 26],
      [12, 25],
      [11.5, 24],
      [11, 23],
      [10.5, 22],
      [10, 21],
      [9.5, 20],
      [9, 19],
      [8.5, 18],
      [8, 17],
      [7.5, 16],
      [7, 15],
      [6.5, 14],
      [6, 13],
      [5.5, 12],
      [5, 11],
      [4.5, 10],
      [4, 9],
      [3.5, 8],
      [3, 7],
      [2.5, 6],
    ],
  },
};

function buildTable(mxM, mxF) {
  const build = (mx) => {
    const r = [];
    let p = 15,
      v = mx;
    while (p >= 2.5) {
      r.push([p, v]);
      p = Math.round((p - 0.5) * 10) / 10;
      v--;
    }
    return r;
  };
  return { M: build(mxM), F: build(mxF) };
}
const SITUP_SCORES = {
  "Under 25": buildTable(60, 58),
  "25-29": buildTable(58, 56),
  "30-34": buildTable(56, 54),
  "35-39": buildTable(54, 52),
  "40-44": buildTable(52, 50),
  "45-49": buildTable(50, 48),
  "50-54": buildTable(48, 46),
  "55-59": buildTable(46, 44),
  "60+": buildTable(44, 42),
};
const CLRC_SCORES = {
  "Under 25": buildTable(60, 58),
  "25-29": buildTable(58, 56),
  "30-34": buildTable(56, 54),
  "35-39": buildTable(54, 52),
  "40-44": buildTable(52, 50),
  "45-49": buildTable(50, 48),
  "50-54": buildTable(48, 46),
  "55-59": buildTable(46, 44),
  "60+": buildTable(44, 42),
};

const RUN_SCORES = {
  "Under 25": {
    M: [
      [50, 805],
      [49.5, 824],
      [49, 843],
      [48, 862],
      [47, 881],
      [46, 900],
      [45, 919],
      [44, 938],
      [43, 957],
      [42, 976],
      [41, 995],
      [40, 1014],
      [39, 1033],
      [38.5, 1052],
      [38, 1071],
      [37.5, 1090],
      [37, 1109],
      [36.5, 1128],
      [36, 1147],
      [35.5, 1176],
      [35, 1185],
    ],
    F: [
      [50, 930],
      [49.5, 960],
      [49, 989],
      [48, 1019],
      [47, 1049],
      [46, 1078],
      [45, 1108],
      [44, 1138],
      [43, 1168],
      [42, 1197],
      [41, 1219],
      [40, 1236],
      [39, 1286],
      [38.5, 1313],
      [38, 1345],
      [37.5, 1375],
      [37, 1404],
      [36.5, 1434],
      [36, 1464],
      [35.5, 1483],
      [35, 1530],
    ],
  },
  "25-29": { M: [[50, 815]], F: [[50, 955]] },
  "30-34": { M: [[50, 822]], F: [[50, 970]] },
  "35-39": { M: [[50, 836]], F: [[50, 972]] },
  "40-44": { M: [[50, 845]], F: [[50, 1005]] },
  "45-49": { M: [[50, 870]], F: [[50, 1015]] },
  "50-54": { M: [[50, 909]], F: [[50, 1030]] },
  "55-59": { M: [[50, 928]], F: [[50, 1063]] },
  "60+": { M: [[50, 1018]], F: [[50, 1100]] },
};

const HAMR_SCORES = {
  "Under 25": {
    M: [
      [50, 87],
      [49.5, 84],
      [49, 81],
      [48, 78],
      [47, 75],
      [46, 72],
      [45, 70],
      [44, 67],
      [43, 65],
      [42, 63],
      [41, 60],
      [40, 58],
      [39, 56],
      [38.5, 54],
      [38, 52],
      [37.5, 51],
      [37, 49],
      [36.5, 47],
      [36, 46],
      [35.5, 44],
      [35, 42],
    ],
    F: [
      [50, 68],
      [49.5, 65],
      [49, 61],
      [48, 58],
      [47, 55],
      [46, 52],
      [45, 49],
      [44, 46],
      [43, 44],
      [42, 41],
      [41, 39],
      [40, 37],
      [39, 35],
      [38.5, 33],
      [38, 31],
      [37.5, 29],
      [37, 28],
      [36.5, 26],
      [36, 24],
      [35.5, 23],
      [35, 21],
    ],
  },
  "25-29": {
    M: [
      [50, 85],
      [35, 42],
    ],
    F: [
      [50, 65],
      [35, 20],
    ],
  },
  "30-34": {
    M: [
      [50, 84],
      [35, 38],
    ],
    F: [
      [50, 63],
      [35, 19],
    ],
  },
  "35-39": {
    M: [
      [50, 82],
      [35, 36],
    ],
    F: [
      [50, 63],
      [35, 18],
    ],
  },
  "40-44": {
    M: [
      [50, 81],
      [35, 32],
    ],
    F: [
      [50, 59],
      [35, 17],
    ],
  },
  "45-49": {
    M: [
      [50, 77],
      [35, 31],
    ],
    F: [
      [50, 58],
      [35, 16],
    ],
  },
  "50-54": {
    M: [
      [50, 71],
      [35, 30],
    ],
    F: [
      [50, 57],
      [35, 14],
    ],
  },
  "55-59": {
    M: [
      [50, 69],
      [35, 27],
    ],
    F: [
      [50, 53],
      [35, 13],
    ],
  },
  "60+": {
    M: [
      [50, 65],
      [35, 26],
    ],
    F: [
      [50, 50],
      [35, 11],
    ],
  },
};

const WHtR_SCORES = [
  [20, 0.49],
  [19, 0.5],
  [18, 0.51],
  [17, 0.52],
  [16, 0.53],
  [15, 0.54],
  [12.5, 0.55],
  [10, 0.56],
  [7.5, 0.57],
  [5, 0.58],
  [2.5, 0.59],
  [0, 0.6],
];

function scoreFromTable(table, value, g, ag) {
  const d = table[ag]?.[g] || [];
  for (const [p, t] of d) if (value >= t) return p;
  return 0;
}
function scoreWHtR(r) {
  for (const [p, t] of WHtR_SCORES) if (r <= t) return p;
  return 0;
}
function scoreRun(s, g, ag) {
  const d = RUN_SCORES[ag]?.[g] || [];
  for (const [p, t] of d) if (s <= t) return p;
  return 35;
}
function scoreHAMR(n, g, ag) {
  const d = HAMR_SCORES[ag]?.[g] || [];
  for (const [p, t] of d) if (n >= t) return p;
  return 35;
}

const HAMR_LEVELS = [
  [1, 7, 9],
  [2, 8, 8],
  [3, 8, 7.58],
  [4, 9, 7.2],
  [5, 9, 6.86],
  [6, 10, 6.55],
  [7, 10, 6.26],
  [8, 11, 6],
  [9, 11, 5.76],
  [10, 11, 5.54],
  [11, 12, 5.33],
  [12, 12, 5.14],
  [13, 13, 4.97],
  [14, 13, 4.8],
  [15, 13, 4.65],
  [16, 14, 4.5],
  [17, 14, 4.36],
  [18, 15, 4.24],
  [19, 15, 4.11],
  [20, 16, 4],
  [21, 16, 3.89],
];
function buildHAMRTimeline() {
  const ev = [];
  let t = 0,
    tot = 0;
  for (const [lv, cnt, iv] of HAMR_LEVELS)
    for (let s = 1; s <= cnt; s++) {
      tot++;
      t += iv * 1000;
      ev.push({
        shuttle: tot,
        level: lv,
        fireAt: Math.round(t),
        isLevelUp: s === cnt,
      });
    }
  return ev;
}
const HAMR_TIMELINE = buildHAMRTimeline();
const HAMR_TOTAL = HAMR_TIMELINE[HAMR_TIMELINE.length - 1].shuttle;

const WORKOUTS = {
  pushup: [
    {
      name: "Push-up Ladder",
      sets: "10 sets",
      reps: "1-2-3-4-5-4-3-2-1 reps",
      rest: "30s",
      tip: "Keep core tight throughout the ladder.",
      duration: "20 min",
      level: "Intermediate",
    },
    {
      name: "Max Effort Sets",
      sets: "5 sets",
      reps: "Max reps per set",
      rest: "2 min",
      tip: "Stop 2 reps before failure to avoid burnout.",
      duration: "15 min",
      level: "Advanced",
    },
    {
      name: "Tempo Push-ups",
      sets: "4 sets",
      reps: "10 reps, 3s descent",
      rest: "90s",
      tip: "Control the descent — that's where strength is built.",
      duration: "18 min",
      level: "Intermediate",
    },
    {
      name: "Diamond & Wide Superset",
      sets: "3 sets",
      reps: "10 + 10 reps",
      rest: "60s",
      tip: "Hit all angles of the chest and triceps.",
      duration: "15 min",
      level: "Intermediate",
    },
    {
      name: "Hand Release Practice",
      sets: "5 sets",
      reps: "10 reps, full release",
      rest: "90s",
      tip: "Lift hands fully off the ground every rep.",
      duration: "20 min",
      level: "Beginner",
    },
    {
      name: "HR Push-up Negatives",
      sets: "4 sets",
      reps: "8 reps, 4s descent",
      rest: "2 min",
      tip: "The slow negative builds lock-out strength for test day.",
      duration: "22 min",
      level: "Advanced",
    },
  ],
  situp: [
    {
      name: "Timed Sit-up Intervals",
      sets: "5 sets",
      reps: "30s on / 15s off",
      rest: "60s",
      tip: "Drive elbows toward knees, not the ceiling.",
      duration: "15 min",
      level: "Beginner",
    },
    {
      name: "Slow Negatives",
      sets: "4 sets",
      reps: "12 reps, 4s descent",
      rest: "60s",
      tip: "Lower slowly to maximize core activation.",
      duration: "18 min",
      level: "Intermediate",
    },
    {
      name: "Sit-up and Hold",
      sets: "3 sets",
      reps: "10 reps, 3s hold",
      rest: "60s",
      tip: "Squeeze the abs hard at the top.",
      duration: "12 min",
      level: "Intermediate",
    },
    {
      name: "CLRC Practice",
      sets: "4 sets",
      reps: "15 reps controlled",
      rest: "60s",
      tip: "Cross ankles, drive knees to chest, avoid momentum.",
      duration: "18 min",
      level: "Beginner",
    },
    {
      name: "Dead Bug Activation",
      sets: "3 sets",
      reps: "10 per side",
      rest: "45s",
      tip: "Keep lower back pressed to the floor.",
      duration: "12 min",
      level: "Beginner",
    },
  ],
  plank: [
    {
      name: "Plank Holds",
      sets: "5 sets",
      reps: "Hold to failure",
      rest: "60s",
      tip: "Squeeze glutes — it protects your lower back.",
      duration: "15 min",
      level: "Beginner",
    },
    {
      name: "Plank Shoulder Taps",
      sets: "4 sets",
      reps: "20 taps",
      rest: "45s",
      tip: "Minimize hip rotation on each tap.",
      duration: "12 min",
      level: "Intermediate",
    },
    {
      name: "Side Plank Series",
      sets: "3 per side",
      reps: "30s each",
      rest: "30s",
      tip: "Stack your feet or stagger for balance.",
      duration: "10 min",
      level: "Intermediate",
    },
    {
      name: "Hollow Body Hold",
      sets: "4 sets",
      reps: "20-30 seconds",
      rest: "45s",
      tip: "Press lower back firmly into the floor.",
      duration: "14 min",
      level: "Advanced",
    },
  ],
  run: [
    {
      name: "2-Mile Tempo Run",
      sets: "1 run",
      reps: "At goal pace",
      rest: "Cooldown walk",
      tip: "Start 10 sec/mile slower to negative split.",
      duration: "25 min",
      level: "Intermediate",
    },
    {
      name: "400m Intervals",
      sets: "8 x 400m",
      reps: "90% effort",
      rest: "90s walk between",
      tip: "Consistent splits matter more than blazing the first few.",
      duration: "35 min",
      level: "Advanced",
    },
    {
      name: "Fartlek Run",
      sets: "20 min",
      reps: "Alternate effort",
      rest: "Continuous",
      tip: "Use landmarks to trigger effort changes.",
      duration: "20 min",
      level: "Intermediate",
    },
    {
      name: "Hill Repeats",
      sets: "6-8 repeats",
      reps: "Sprint uphill",
      rest: "Walk down",
      tip: "Builds the leg drive and lung capacity.",
      duration: "30 min",
      level: "Advanced",
    },
    {
      name: "HAMR Shuttle Practice",
      sets: "3 sets",
      reps: "10 min at test pace",
      rest: "3 min",
      tip: "Focus on quick direction changes at the line.",
      duration: "40 min",
      level: "Intermediate",
    },
  ],
  whtr: [
    {
      name: "Cardio Circuit",
      sets: "3 rounds",
      reps: "20 jacks, 15 burpees, 10 squat jumps",
      rest: "60s",
      tip: "Caloric burn is your friend — pair with nutrition control.",
      duration: "25 min",
      level: "Intermediate",
    },
    {
      name: "Brisk Walk",
      sets: "5 days/week",
      reps: "30-45 min",
      rest: "Active recovery",
      tip: "Zone 2 cardio is powerful for body composition.",
      duration: "40 min",
      level: "Beginner",
    },
    {
      name: "HIIT Intervals",
      sets: "10 x 1 min",
      reps: "Max effort",
      rest: "1 min easy",
      tip: "High intensity preserves muscle while burning fat.",
      duration: "20 min",
      level: "Advanced",
    },
    {
      name: "Strength Circuit",
      sets: "3 rounds",
      reps: "10 squats, lunges, push-ups, 30s plank",
      rest: "90s",
      tip: "Muscle mass raises resting metabolism.",
      duration: "30 min",
      level: "Intermediate",
    },
  ],
};

const SCHEDULES = {
  pushup: [
    "Push-up Ladder",
    "Max Effort Sets",
    "Rest",
    "Tempo Push-ups",
    "Diamond & Wide Superset",
    "Rest",
    "Hand Release Practice",
  ],
  situp: [
    "Timed Sit-up Intervals",
    "Slow Negatives",
    "Rest",
    "Sit-up and Hold",
    "CLRC Practice",
    "Rest",
    "Dead Bug Activation",
  ],
  plank: [
    "Plank Holds",
    "Plank Shoulder Taps",
    "Rest",
    "Side Plank Series",
    "Hollow Body Hold",
    "Rest",
    "Plank Holds",
  ],
  run: [
    "2-Mile Tempo Run",
    "400m Intervals",
    "Rest",
    "Fartlek Run",
    "Rest",
    "Hill Repeats",
    "HAMR Shuttle Practice",
  ],
  whtr: [
    "Cardio Circuit",
    "Brisk Walk",
    "HIIT Intervals",
    "Cardio Circuit",
    "Rest",
    "Strength Circuit",
    "Brisk Walk",
  ],
};

const TIPS = [
  "Hydrate 16-20 oz of water 2 hours before any cardio session.",
  "Sleep is recovery — aim for 7-9 hours before your PFRA.",
  "Practice the exact test order: aerobic, then muscular endurance.",
  "Breathe out on the exertion phase of every push-up and sit-up.",
  "Taper your training the week before your assessment.",
  "Core bracing during your plank protects your lower back.",
  "A warm-up mile dramatically improves your 2-mile run time.",
  "Consistent moderate training beats occasional intense sessions.",
];

const THEMES = {
  blue: {
    bg: "#F0F4FF",
    surface: "#FFFFFF",
    card: "#FFFFFF",
    accent: "#1E4FD8",
    accentDark: "#1240B0",
    text: "#0A1628",
    textMuted: "#6B7BA4",
    border: "#E0E8FF",
    success: "#059A5E",
    danger: "#D93A56",
    tabBar: "#FFFFFF",
    hero1: "#0A1628",
    hero2: "#1E3A7A",
    name: "blue",
  },
  black: {
    bg: "#111111",
    surface: "#1C1C1C",
    card: "#242424",
    accent: "#C8A84B",
    accentDark: "#A8883B",
    text: "#F0F0F0",
    textMuted: "#888888",
    border: "#2A2A2A",
    success: "#00C97A",
    danger: "#FF4D6D",
    tabBar: "#161616",
    hero1: "#000000",
    hero2: "#1A1A1A",
    name: "black",
  },
  white: {
    bg: "#FAFAFA",
    surface: "#FFFFFF",
    card: "#FFFFFF",
    accent: "#1E4FD8",
    accentDark: "#1240B0",
    text: "#111827",
    textMuted: "#6B7280",
    border: "#E5E7EB",
    success: "#059A5E",
    danger: "#D93A56",
    tabBar: "#FFFFFF",
    hero1: "#111827",
    hero2: "#1F2937",
    name: "white",
  },
};

const CARD_GRADIENTS = [
  ["#1E4FD8", "#3B6EFF"],
  ["#059A5E", "#10B981"],
  ["#D97706", "#F59E0B"],
  ["#7C3AED", "#A78BFA"],
  ["#D93A56", "#FB7185"],
  ["#0891B2", "#22D3EE"],
];
const COMP_COLORS = {
  pushup: "#1E4FD8",
  situp: "#059A5E",
  plank: "#D97706",
  run: "#D93A56",
  whtr: "#7C3AED",
};
const LEVEL_COLORS = {
  Beginner: "#059A5E",
  Intermediate: "#D97706",
  Advanced: "#D93A56",
};

const pad = (n) => String(n).padStart(2, "0");
const fmtTime = (s) => `${pad(Math.floor(s / 60))}:${pad(s % 60)}`;
const daysUntil = (d) => {
  if (!d) return null;
  return Math.ceil((new Date(d) - new Date()) / 86400000);
};
const todayStr = () =>
  new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
const nowStr = () =>
  new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
const dowIdx = () => new Date().getDay();
const greet = () => {
  const h = new Date().getHours();
  return h < 12 ? "Good Morning" : h < 17 ? "Good Afternoon" : "Good Evening";
};

function useAudioCtx() {
  const ref = useRef(null);
  const getCtx = () => {
    if (!ref.current)
      ref.current = new (window.AudioContext || window.webkitAudioContext)();
    return ref.current;
  };
  const beep = (freq = 880, dur = 0.12, vol = 0.6) => {
    try {
      const c = getCtx(),
        o = c.createOscillator(),
        g = c.createGain();
      o.connect(g);
      g.connect(c.destination);
      o.frequency.value = freq;
      g.gain.setValueAtTime(vol, c.currentTime);
      g.gain.exponentialRampToValueAtTime(0.001, c.currentTime + dur);
      o.start();
      o.stop(c.currentTime + dur);
    } catch {}
  };
  return {
    beep,
    double: () => {
      beep(660, 0.12, 0.5);
      setTimeout(() => beep(880, 0.15, 0.6), 160);
    },
    levelUp: () => {
      beep(660, 0.1, 0.4);
      setTimeout(() => beep(780, 0.1, 0.5), 130);
      setTimeout(() => beep(1040, 0.2, 0.6), 280);
    },
  };
}

function Ic({ n, s = 22, c = "#fff", fill = "none" }) {
  const strokeProps = {
    stroke: c,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };
  const m = {
    home: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill={fill}
        {...strokeProps}
      >
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
    target: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill={fill}
        {...strokeProps}
      >
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="6" />
        <circle cx="12" cy="12" r="2" />
      </svg>
    ),
    timer: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill={fill}
        {...strokeProps}
      >
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
    chart: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill={fill}
        {...strokeProps}
      >
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
        <line x1="2" y1="20" x2="22" y2="20" />
      </svg>
    ),
    users: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill={fill}
        {...strokeProps}
      >
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    user: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill={fill}
        {...strokeProps}
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
    chevron: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        {...strokeProps}
      >
        <polyline points="9 18 15 12 9 6" />
      </svg>
    ),
    back: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        {...strokeProps}
      >
        <polyline points="15 18 9 12 15 6" />
      </svg>
    ),
    check: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        stroke={c}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    ),
    play: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill={c}>
        <polygon points="5 3 19 12 5 21 5 3" />
      </svg>
    ),
    pause: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill={c}>
        <rect x="6" y="4" width="4" height="16" />
        <rect x="14" y="4" width="4" height="16" />
      </svg>
    ),
    reset: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        {...strokeProps}
      >
        <polyline points="1 4 1 10 7 10" />
        <path d="M3.51 15a9 9 0 1 0 .49-3.1" />
      </svg>
    ),
    send: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        {...strokeProps}
      >
        <line x1="22" y1="2" x2="11" y2="13" />
        <polygon points="22 2 15 22 11 13 2 9 22 2" />
      </svg>
    ),
    heart: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill={fill}
        {...strokeProps}
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    ),
    lock: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        {...strokeProps}
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    ),
    bell: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        {...strokeProps}
      >
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
    ),
    trash: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        {...strokeProps}
      >
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        <path d="M10 11v6" />
        <path d="M14 11v6" />
        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
      </svg>
    ),
    camera: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        {...strokeProps}
      >
        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
        <circle cx="12" cy="13" r="4" />
      </svg>
    ),
    globe: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        {...strokeProps}
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
    award: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        {...strokeProps}
      >
        <circle cx="12" cy="8" r="7" />
        <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
      </svg>
    ),
    plus: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        stroke={c}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
    ),
    pin: (
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        {...strokeProps}
      >
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
  };
  return m[n] || null;
}

export default function App() {
  const [tab, setTab] = useState("home");
  const [theme, setTheme] = useState("blue");
  const [isPro, setIsPro] = useState(false);
  const T = THEMES[theme];

  const [profile, setProfile] = useState({
    name: "",
    rank: "",
    gender: "M",
    age: "",
    unit: "",
    pfraDate: "",
    avatar: "",
  });
  const [savedScores, setSavedScores] = useState([]);
  const [workoutLog, setWorkoutLog] = useState({});
  const [goals, setGoals] = useState({
    pushup: true,
    situp: true,
    run: true,
    plank: false,
    whtr: false,
  });
  const [friends, setFriends] = useState([
    { id: 1, name: "MSgt Rivera", status: "Active", score: 92.5 },
    { id: 2, name: "SrA Chen", status: "Active", score: 88 },
    { id: 3, name: "SSgt Williams", status: "Last seen 2h ago", score: 91 },
  ]);
  // User's computed rank — derived from latest PFRA score if available, else a sensible default
  const lastScore = savedScores[savedScores.length - 1]?.total;
  const userRanks = {
    local: lastScore ? Math.max(1, Math.round(50 - lastScore * 0.45)) : null, // out of ~120 at base
    regional: lastScore ? Math.max(1, Math.round(2800 - lastScore * 25)) : null, // out of ~12,000
    world: lastScore ? Math.max(1, Math.round(95000 - lastScore * 850)) : null, // out of ~340,000
  };
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      from: "MSgt Rivera",
      msg: "Great job on the interval session today!",
      time: "2h ago",
      read: false,
    },
    {
      id: 2,
      from: "SrA Chen",
      msg: "Anyone doing track tomorrow at 0600?",
      time: "5h ago",
      read: true,
    },
    {
      id: 3,
      from: "SSgt Williams",
      msg: "Check out this 8-week push-up plan I built.",
      time: "1d ago",
      read: true,
    },
  ]);

  const unread = notifications.filter((n) => !n.read).length;

  const css = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&display=swap');
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'DM Sans', sans-serif; background: ${T.bg}; color: ${T.text}; }
    ::-webkit-scrollbar { width: 0; height: 0; }
    input, select, textarea, button { font-family: 'DM Sans', sans-serif; }
    button { cursor: pointer; border: none; outline: none; background: none; }
  `;

  return (
    <>
      <style>{css}</style>
      <div
        style={{
          maxWidth: 430,
          margin: "0 auto",
          height: "100dvh",
          display: "flex",
          flexDirection: "column",
          background: T.bg,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            paddingBottom: isPro ? 72 : 104,
          }}
        >
          {tab === "home" && (
            <HomeTab
              T={T}
              profile={profile}
              savedScores={savedScores}
              workoutLog={workoutLog}
              setWorkoutLog={setWorkoutLog}
              goals={goals}
              isPro={isPro}
              setIsPro={setIsPro}
              unread={unread}
              setTab={setTab}
              notifications={notifications}
              setNotifications={setNotifications}
            />
          )}
          {tab === "goals" && (
            <GoalsTab
              T={T}
              goals={goals}
              setGoals={setGoals}
              workoutLog={workoutLog}
              setWorkoutLog={setWorkoutLog}
              isPro={isPro}
            />
          )}
          {tab === "timer" && <TimerTab T={T} />}
          {tab === "scores" && (
            <ScoresTab
              T={T}
              profile={profile}
              savedScores={savedScores}
              setSavedScores={setSavedScores}
            />
          )}
          {tab === "community" && (
            <CommunityTab
              T={T}
              profile={profile}
              notifications={notifications}
              setNotifications={setNotifications}
              isPro={isPro}
              friends={friends}
              setFriends={setFriends}
              userRanks={userRanks}
              savedScores={savedScores}
            />
          )}
          {tab === "profile" && (
            <ProfileTab
              T={T}
              profile={profile}
              setProfile={setProfile}
              theme={theme}
              setTheme={setTheme}
              isPro={isPro}
              setIsPro={setIsPro}
              userRanks={userRanks}
            />
          )}
        </div>
        {!isPro && (
          <div
            style={{
              background: "#0A0A0A",
              borderTop: "1px solid #222",
              padding: "6px 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexShrink: 0,
            }}
          >
            <span style={{ fontSize: 11, color: "#666" }}>
              Ad · Upgrade to remove
            </span>
            <button
              onClick={() => setIsPro(true)}
              style={{
                background: T.accent,
                color: "#fff",
                borderRadius: 20,
                padding: "4px 14px",
                fontSize: 11,
                fontWeight: 700,
              }}
            >
              Go Pro
            </button>
          </div>
        )}
        <TabBar T={T} tab={tab} setTab={setTab} />
      </div>
    </>
  );
}

function TabBar({ T, tab, setTab }) {
  const tabs = [
    { id: "home", n: "home", l: "Home" },
    { id: "goals", n: "target", l: "Goals" },
    { id: "timer", n: "timer", l: "Timer" },
    { id: "scores", n: "chart", l: "PFRA" },
    { id: "community", n: "users", l: "Squad" },
  ];
  return (
    <div
      style={{
        background: T.tabBar,
        borderTop: `1px solid ${T.border}`,
        display: "flex",
        flexShrink: 0,
      }}
    >
      {tabs.map((t) => (
        <button
          key={t.id}
          onClick={() => setTab(t.id)}
          style={{
            flex: 1,
            padding: "10px 0 8px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 4,
          }}
        >
          <Ic n={t.n} s={22} c={tab === t.id ? T.accent : T.textMuted} />
          <span
            style={{
              fontSize: 10,
              fontWeight: 600,
              color: tab === t.id ? T.accent : T.textMuted,
              letterSpacing: 0.2,
            }}
          >
            {t.l}
          </span>
          {tab === t.id && (
            <div
              style={{
                width: 4,
                height: 4,
                borderRadius: 2,
                background: T.accent,
                marginTop: -2,
              }}
            />
          )}
        </button>
      ))}
    </div>
  );
}

function HomeTab({
  T,
  profile,
  savedScores,
  workoutLog,
  setWorkoutLog,
  goals,
  isPro,
  setIsPro,
  unread,
  setTab,
  notifications,
  setNotifications,
}) {
  const [time, setTime] = useState(nowStr());
  const [detail, setDetail] = useState(null);
  const [detailComp, setDetailComp] = useState(null);
  const [tipIdx] = useState(Math.floor(Math.random() * TIPS.length));

  useEffect(() => {
    const id = setInterval(() => setTime(nowStr()), 1000);
    return () => clearInterval(id);
  }, []);

  const countdown = daysUntil(profile.pfraDate);
  const lastScore = savedScores[savedScores.length - 1];
  const dow = dowIdx();
  const todayWorkouts = Object.entries(goals)
    .filter(([, v]) => v)
    .map(([k]) => {
      const sched = SCHEDULES[k];
      const nm = sched[dow % sched.length];
      if (nm === "Rest") return null;
      return { comp: k, name: nm };
    })
    .filter(Boolean);

  if (detail) {
    return (
      <WorkoutDetail
        T={T}
        workout={detail}
        comp={detailComp}
        workoutLog={workoutLog}
        setWorkoutLog={setWorkoutLog}
        onBack={() => {
          setDetail(null);
          setDetailComp(null);
        }}
      />
    );
  }

  const displayName = profile.rank
    ? `${profile.rank} ${profile.name || ""}`.trim()
    : profile.name || "Airman";

  return (
    <div>
      {/* HERO */}
      <div
        style={{
          background: `linear-gradient(135deg, ${T.hero1} 0%, ${T.hero2} 100%)`,
          padding: "20px 20px 28px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: -50,
            right: -50,
            width: 180,
            height: 180,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.03)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            width: 90,
            height: 90,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.05)",
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: 20,
            position: "relative",
          }}
        >
          <div>
            <div
              style={{
                color: "rgba(255,255,255,0.6)",
                fontSize: 13,
                fontWeight: 500,
                marginBottom: 3,
              }}
            >
              {greet()}
            </div>
            <div
              style={{
                color: "#fff",
                fontSize: 22,
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >
              {displayName}
            </div>
            <div
              style={{
                color: "rgba(255,255,255,0.5)",
                fontSize: 12,
                marginTop: 3,
              }}
            >
              {todayStr()}
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={() => {
                setTab("community");
                setNotifications((n) => n.map((x) => ({ ...x, read: true })));
              }}
              style={{
                position: "relative",
                background: "rgba(255,255,255,0.12)",
                borderRadius: 12,
                padding: 9,
              }}
            >
              <Ic n="bell" s={20} c="#fff" />
              {unread > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: -3,
                    right: -3,
                    background: "#FF4D6D",
                    color: "#fff",
                    fontSize: 9,
                    borderRadius: 8,
                    padding: "1px 5px",
                    fontWeight: 700,
                  }}
                >
                  {unread}
                </span>
              )}
            </button>
            <button
              onClick={() => setTab("profile")}
              style={{
                background: profile.avatar
                  ? "transparent"
                  : "rgba(255,255,255,0.12)",
                borderRadius: 12,
                padding: profile.avatar ? 0 : 9,
                overflow: "hidden",
                width: profile.avatar ? 38 : "auto",
                height: profile.avatar ? 38 : "auto",
                border: profile.avatar
                  ? "2px solid rgba(255,255,255,0.3)"
                  : "none",
              }}
            >
              {profile.avatar ? (
                <img
                  src={profile.avatar}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              ) : (
                <Ic n="user" s={20} c="#fff" />
              )}
            </button>
          </div>
        </div>
        {countdown !== null ? (
          <div
            style={{
              background:
                countdown <= 7
                  ? "rgba(217,58,86,0.25)"
                  : "rgba(255,255,255,0.10)",
              borderRadius: 16,
              padding: "14px 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: `1px solid ${
                countdown <= 7
                  ? "rgba(217,58,86,0.5)"
                  : "rgba(255,255,255,0.13)"
              }`,
              position: "relative",
            }}
          >
            <div>
              <div
                style={{
                  color: "rgba(255,255,255,0.65)",
                  fontSize: 11,
                  fontWeight: 600,
                  letterSpacing: 0.5,
                  textTransform: "uppercase",
                  marginBottom: 2,
                }}
              >
                Next PFRA
              </div>
              <div
                style={{
                  color: countdown <= 7 ? "#FF8099" : "#fff",
                  fontSize: 28,
                  fontWeight: 700,
                  lineHeight: 1,
                }}
              >
                {countdown > 0
                  ? `${countdown} Days`
                  : countdown === 0
                  ? "Today"
                  : "Overdue"}
              </div>
            </div>
            {lastScore && (
              <div style={{ textAlign: "right" }}>
                <div
                  style={{
                    color: "rgba(255,255,255,0.6)",
                    fontSize: 11,
                    marginBottom: 2,
                  }}
                >
                  Last Score
                </div>
                <div
                  style={{
                    color:
                      lastScore.total >= 90
                        ? "#34D399"
                        : lastScore.total >= 75
                        ? "#FCD34D"
                        : "#F87171",
                    fontSize: 30,
                    fontWeight: 700,
                    lineHeight: 1,
                  }}
                >
                  {lastScore.total.toFixed(1)}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div
            style={{
              background: "rgba(255,255,255,0.08)",
              borderRadius: 16,
              padding: "12px 16px",
              textAlign: "center",
              border: "1px solid rgba(255,255,255,0.10)",
            }}
          >
            <div style={{ color: "rgba(255,255,255,0.55)", fontSize: 13 }}>
              Set your PFRA date in Profile to see countdown
            </div>
          </div>
        )}
      </div>

      <div style={{ padding: "0 16px" }}>
        {/* Today's Plan */}
        <div
          style={{
            background: T.card,
            borderRadius: 20,
            padding: 18,
            boxShadow: "0 4px 20px rgba(0,0,0,0.07)",
            marginBottom: 16,
            border: `1px solid ${T.border}`,
            marginTop: 16,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 14,
            }}
          >
            <div style={{ fontSize: 17, fontWeight: 700, color: T.text }}>
              Today's Plan
            </div>
            <span style={{ fontSize: 12, color: T.accent, fontWeight: 600 }}>
              {todayWorkouts.length} workouts
            </span>
          </div>
          {todayWorkouts.length === 0 ? (
            <div style={{ textAlign: "center", padding: "18px 0" }}>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: T.text,
                  marginBottom: 4,
                }}
              >
                Rest Day
              </div>
              <div style={{ fontSize: 12, color: T.textMuted }}>
                Recovery is training too.
              </div>
            </div>
          ) : (
            todayWorkouts.map((w, i) => {
              const wData =
                WORKOUTS[w.comp]?.find((x) => x.name === w.name) ||
                WORKOUTS[w.comp]?.[0];
              const [c1, c2] = CARD_GRADIENTS[i % CARD_GRADIENTS.length];
              return (
                <button
                  key={i}
                  onClick={() => {
                    setDetail(wData);
                    setDetailComp(w.comp);
                  }}
                  style={{
                    width: "100%",
                    background: `linear-gradient(135deg, ${c1}, ${c2})`,
                    borderRadius: 14,
                    padding: "14px 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: i < todayWorkouts.length - 1 ? 10 : 0,
                    textAlign: "left",
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 10,
                        color: "rgba(255,255,255,0.7)",
                        fontWeight: 700,
                        letterSpacing: 0.8,
                        textTransform: "uppercase",
                        marginBottom: 3,
                      }}
                    >
                      {w.comp.toUpperCase()}
                    </div>
                    <div
                      style={{
                        fontSize: 15,
                        fontWeight: 700,
                        color: "#fff",
                        marginBottom: 4,
                      }}
                    >
                      {w.name}
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                      <span
                        style={{
                          fontSize: 11,
                          color: "rgba(255,255,255,0.75)",
                        }}
                      >
                        {wData?.duration}
                      </span>
                      <span
                        style={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}
                      >
                        ·
                      </span>
                      <span
                        style={{
                          fontSize: 11,
                          color: "rgba(255,255,255,0.75)",
                        }}
                      >
                        {wData?.level}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: 10,
                      padding: 9,
                    }}
                  >
                    <Ic n="play" s={16} c="#fff" />
                  </div>
                </button>
              );
            })
          )}
        </div>

        {/* Quick Actions */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 12,
            marginBottom: 16,
          }}
        >
          {[
            {
              label: "PFRA Score",
              sub: "Calculate & save",
              icon: "chart",
              color: T.accent,
              tab: "scores",
            },
            {
              label: "HAMR Timer",
              sub: "Beep test ready",
              icon: "timer",
              color: "#059A5E",
              tab: "timer",
            },
          ].map((item, i) => (
            <button
              key={i}
              onClick={() => setTab(item.tab)}
              style={{
                background: T.card,
                border: `1px solid ${T.border}`,
                borderRadius: 18,
                padding: "16px 14px",
                textAlign: "left",
                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
              }}
            >
              <div
                style={{
                  background: item.color,
                  borderRadius: 10,
                  width: 36,
                  height: 36,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
              >
                <Ic n={item.icon} s={18} c="#fff" />
              </div>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: T.text,
                  marginBottom: 2,
                }}
              >
                {item.label}
              </div>
              <div style={{ fontSize: 11, color: T.textMuted }}>{item.sub}</div>
            </button>
          ))}
        </div>

        {/* Tip */}
        <div
          style={{
            background: `linear-gradient(135deg, ${T.accent}18, ${T.accent}06)`,
            border: `1px solid ${T.accent}28`,
            borderRadius: 18,
            padding: 18,
            marginBottom: 16,
          }}
        >
          <div
            style={{
              fontSize: 11,
              fontWeight: 700,
              color: T.accent,
              letterSpacing: 0.5,
              textTransform: "uppercase",
              marginBottom: 8,
            }}
          >
            Airman's Tip
          </div>
          <div style={{ fontSize: 14, color: T.text, lineHeight: 1.65 }}>
            {TIPS[tipIdx]}
          </div>
        </div>

        {/* Pro upsell */}
        {!isPro && (
          <div
            style={{
              background: `linear-gradient(135deg, ${T.hero1}, ${T.hero2})`,
              borderRadius: 20,
              padding: 20,
              marginBottom: 8,
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: -20,
                right: -20,
                width: 100,
                height: 100,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.04)",
              }}
            />
            <div
              style={{
                fontSize: 13,
                fontWeight: 700,
                color: "rgba(255,255,255,0.65)",
                marginBottom: 4,
              }}
            >
              FORCEFIT PRO
            </div>
            <div
              style={{
                fontSize: 18,
                fontWeight: 700,
                color: "#fff",
                marginBottom: 6,
              }}
            >
              Go ad-free + unlock everything
            </div>
            <div
              style={{
                fontSize: 13,
                color: "rgba(255,255,255,0.6)",
                marginBottom: 16,
              }}
            >
              Periodized plans, analytics, unit leaderboards.
            </div>
            <button
              onClick={() => setIsPro(true)}
              style={{
                background: "#fff",
                color: "#0A1628",
                borderRadius: 24,
                padding: "10px 24px",
                fontSize: 13,
                fontWeight: 700,
              }}
            >
              Upgrade Now
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function WorkoutDetail({
  T,
  workout,
  comp,
  workoutLog,
  setWorkoutLog,
  onBack,
}) {
  const key = `${todayStr()}-${workout.name}`;
  const isLogged = workoutLog[key];
  const [done, setDone] = useState(false);
  const idx = Object.keys(WORKOUTS).indexOf(comp);
  const [c1, c2] = CARD_GRADIENTS[idx >= 0 ? idx % CARD_GRADIENTS.length : 0];
  return (
    <div>
      <div
        style={{
          background: `linear-gradient(145deg, ${c1}, ${c2})`,
          padding: "52px 20px 28px",
          position: "relative",
          minHeight: 200,
        }}
      >
        <button
          onClick={onBack}
          style={{
            position: "absolute",
            top: 14,
            left: 14,
            background: "rgba(255,255,255,0.15)",
            borderRadius: 10,
            padding: 9,
          }}
        >
          <Ic n="back" s={20} c="#fff" />
        </button>
        <div
          style={{
            fontSize: 10,
            color: "rgba(255,255,255,0.7)",
            fontWeight: 700,
            letterSpacing: 1,
            textTransform: "uppercase",
            marginBottom: 6,
          }}
        >
          {comp.toUpperCase()}
        </div>
        <div
          style={{
            fontSize: 24,
            fontWeight: 700,
            color: "#fff",
            lineHeight: 1.2,
            marginBottom: 10,
          }}
        >
          {workout.name}
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <span
            style={{
              background: "rgba(255,255,255,0.18)",
              borderRadius: 20,
              padding: "4px 12px",
              fontSize: 12,
              color: "rgba(255,255,255,0.92)",
              fontWeight: 600,
            }}
          >
            {workout.duration}
          </span>
          <span
            style={{
              background: "rgba(255,255,255,0.18)",
              borderRadius: 20,
              padding: "4px 12px",
              fontSize: 12,
              color: "rgba(255,255,255,0.92)",
              fontWeight: 600,
            }}
          >
            {workout.level}
          </span>
        </div>
      </div>
      <div style={{ padding: 20 }}>
        <div
          style={{
            background: T.card,
            border: `1px solid ${T.border}`,
            borderRadius: 18,
            overflow: "hidden",
            marginBottom: 14,
          }}
        >
          {[
            ["Sets", workout.sets],
            ["Reps / Time", workout.reps],
            ["Rest", workout.rest],
          ].map(([label, val], i, arr) => (
            <div
              key={label}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "13px 16px",
                borderBottom:
                  i < arr.length - 1 ? `1px solid ${T.border}` : "none",
              }}
            >
              <span
                style={{ fontSize: 13, color: T.textMuted, fontWeight: 500 }}
              >
                {label}
              </span>
              <span style={{ fontSize: 13, fontWeight: 700, color: T.text }}>
                {val}
              </span>
            </div>
          ))}
        </div>
        <div
          style={{
            background: `${c1}14`,
            border: `1px solid ${c1}30`,
            borderRadius: 16,
            padding: 16,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              fontSize: 11,
              fontWeight: 700,
              color: c1,
              letterSpacing: 0.5,
              textTransform: "uppercase",
              marginBottom: 6,
            }}
          >
            Coaching Cue
          </div>
          <div style={{ fontSize: 14, color: T.text, lineHeight: 1.65 }}>
            {workout.tip}
          </div>
        </div>
        <button
          onClick={() => {
            setWorkoutLog({ ...workoutLog, [key]: true });
            setDone(true);
          }}
          disabled={isLogged || done}
          style={{
            width: "100%",
            background: isLogged || done ? "#059A5E" : c1,
            color: "#fff",
            borderRadius: 16,
            padding: "16px 0",
            fontSize: 16,
            fontWeight: 700,
            boxShadow: isLogged || done ? "none" : `0 4px 16px ${c1}50`,
          }}
        >
          {isLogged || done ? "Workout Logged" : "Mark Complete"}
        </button>
      </div>
    </div>
  );
}

function GoalsTab({ T, goals, setGoals, workoutLog, setWorkoutLog, isPro }) {
  const [activeComp, setActiveComp] = useState(null);
  const [detail, setDetail] = useState(null);

  const comps = [
    {
      key: "pushup",
      label: "Push-Up",
      sub: "Muscular Endurance",
      color: "#1E4FD8",
    },
    {
      key: "situp",
      label: "Sit-Up & Crunch",
      sub: "Core Strength",
      color: "#059A5E",
    },
    {
      key: "plank",
      label: "Forearm Plank",
      sub: "Core Endurance",
      color: "#D97706",
    },
    {
      key: "run",
      label: "2-Mile Run / HAMR",
      sub: "Cardiorespiratory",
      color: "#D93A56",
    },
    {
      key: "whtr",
      label: "Body Composition",
      sub: "Waist-to-Height Ratio",
      color: "#7C3AED",
    },
  ];

  if (detail && activeComp) {
    return (
      <WorkoutDetail
        T={T}
        workout={detail}
        comp={activeComp}
        workoutLog={workoutLog}
        setWorkoutLog={setWorkoutLog}
        onBack={() => setDetail(null)}
      />
    );
  }

  if (activeComp) {
    const comp = comps.find((c) => c.key === activeComp);
    const list = WORKOUTS[activeComp] || [];
    const sched = SCHEDULES[activeComp];
    const days = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    return (
      <div>
        <div
          style={{
            background: `linear-gradient(135deg, ${comp.color}, ${comp.color}BB)`,
            padding: "52px 20px 24px",
            position: "relative",
          }}
        >
          <button
            onClick={() => setActiveComp(null)}
            style={{
              position: "absolute",
              top: 14,
              left: 14,
              background: "rgba(255,255,255,0.15)",
              borderRadius: 10,
              padding: 9,
            }}
          >
            <Ic n="back" s={20} c="#fff" />
          </button>
          <div
            style={{
              fontSize: 10,
              color: "rgba(255,255,255,0.7)",
              fontWeight: 700,
              letterSpacing: 1,
              textTransform: "uppercase",
              marginBottom: 4,
            }}
          >
            PFRA Component
          </div>
          <div
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: "#fff",
              marginBottom: 4,
            }}
          >
            {comp.label}
          </div>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)" }}>
            {comp.sub}
          </div>
        </div>
        <div style={{ padding: 16 }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: T.text,
              marginBottom: 10,
            }}
          >
            Weekly Schedule
          </div>
          <div
            style={{
              display: "flex",
              gap: 6,
              marginBottom: 20,
              overflowX: "auto",
              paddingBottom: 4,
            }}
          >
            {days.map((d, i) => {
              const nm = sched[i];
              const isRest = nm === "Rest";
              return (
                <div
                  key={d}
                  style={{
                    flexShrink: 0,
                    background: isRest ? T.bg : comp.color,
                    border: `1px solid ${isRest ? T.border : comp.color}`,
                    borderRadius: 12,
                    padding: "10px 10px",
                    textAlign: "center",
                    minWidth: 44,
                  }}
                >
                  <div
                    style={{
                      fontSize: 10,
                      color: isRest ? T.textMuted : "rgba(255,255,255,0.8)",
                      marginBottom: 3,
                      fontWeight: 600,
                    }}
                  >
                    {d}
                  </div>
                  <div
                    style={{
                      fontSize: 9,
                      fontWeight: 700,
                      color: isRest ? T.textMuted : "#fff",
                      textTransform: "uppercase",
                    }}
                  >
                    {isRest ? "Rest" : "Train"}
                  </div>
                </div>
              );
            })}
          </div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: T.text,
              marginBottom: 10,
            }}
          >
            Workout Library
          </div>
          {list.map((w, i) => {
            const [c1] = CARD_GRADIENTS[i % CARD_GRADIENTS.length];
            return (
              <button
                key={i}
                onClick={() => setDetail(w)}
                style={{
                  width: "100%",
                  background: T.card,
                  border: `1px solid ${T.border}`,
                  borderRadius: 16,
                  padding: "14px 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  marginBottom: 10,
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    background: `${c1}18`,
                    borderRadius: 10,
                    width: 40,
                    height: 40,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <div
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: 5,
                      background: c1,
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontSize: 14,
                      fontWeight: 700,
                      color: T.text,
                      marginBottom: 3,
                    }}
                  >
                    {w.name}
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <span style={{ fontSize: 11, color: T.textMuted }}>
                      {w.duration}
                    </span>
                    <span
                      style={{
                        fontSize: 11,
                        color: LEVEL_COLORS[w.level] || T.textMuted,
                        fontWeight: 600,
                      }}
                    >
                      {w.level}
                    </span>
                  </div>
                </div>
                <Ic n="chevron" s={18} c={T.textMuted} />
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          background: T.card,
          padding: "20px 20px 16px",
          borderBottom: `1px solid ${T.border}`,
        }}
      >
        <div
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: T.text,
            marginBottom: 4,
          }}
        >
          Training Goals
        </div>
        <div style={{ fontSize: 13, color: T.textMuted }}>
          Toggle PFRA components to build your schedule
        </div>
      </div>
      <div style={{ padding: 16 }}>
        {comps.map((comp) => (
          <div
            key={comp.key}
            style={{
              background: T.card,
              border: `1px solid ${goals[comp.key] ? comp.color : T.border}`,
              borderRadius: 18,
              padding: 16,
              marginBottom: 12,
              boxShadow: goals[comp.key]
                ? `0 2px 12px ${comp.color}20`
                : "none",
              transition: "all 0.2s",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                marginBottom: goals[comp.key] ? 14 : 0,
              }}
            >
              <div
                style={{
                  background: goals[comp.key] ? comp.color : `${comp.color}20`,
                  borderRadius: 12,
                  width: 44,
                  height: 44,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  transition: "background 0.2s",
                }}
              >
                <Ic
                  n="target"
                  s={20}
                  c={goals[comp.key] ? "#fff" : comp.color}
                />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: T.text }}>
                  {comp.label}
                </div>
                <div style={{ fontSize: 12, color: T.textMuted }}>
                  {comp.sub}
                </div>
              </div>
              <button
                onClick={() =>
                  setGoals({ ...goals, [comp.key]: !goals[comp.key] })
                }
                style={{
                  width: 48,
                  height: 28,
                  borderRadius: 14,
                  background: goals[comp.key] ? comp.color : T.border,
                  position: "relative",
                  transition: "background 0.2s",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 3,
                    left: goals[comp.key] ? 22 : 3,
                    width: 22,
                    height: 22,
                    borderRadius: 11,
                    background: "#fff",
                    transition: "left 0.2s",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
                  }}
                />
              </button>
            </div>
            {goals[comp.key] && (
              <button
                onClick={() => setActiveComp(comp.key)}
                style={{
                  width: "100%",
                  background: `${comp.color}12`,
                  border: `1px solid ${comp.color}30`,
                  borderRadius: 12,
                  padding: "10px 0",
                  color: comp.color,
                  fontSize: 13,
                  fontWeight: 700,
                }}
              >
                View Workouts
              </button>
            )}
          </div>
        ))}
        {!isPro && (
          <div
            style={{
              background: T.card,
              border: `1px dashed ${T.accent}`,
              borderRadius: 18,
              padding: 20,
              textAlign: "center",
              marginTop: 4,
            }}
          >
            <Ic n="lock" s={24} c={T.accent} />
            <div style={{ fontSize: 13, color: T.textMuted, marginTop: 8 }}>
              Pro: AI-generated 8-week periodized plans based on your PFRA
              results
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function TimerTab({ T }) {
  const [timerMode, setTimerMode] = useState("standard");
  const [seconds, setSeconds] = useState(0);
  const [running, setRunning] = useState(false);
  const [mode, setMode] = useState("stopwatch");
  const [preset, setPreset] = useState(null);
  const intRef = useRef(null);

  const [hamrRunning, setHamrRunning] = useState(false);
  const [hamrDone, setHamrDone] = useState(false);
  const [hamrShuttle, setHamrShuttle] = useState(0);
  const [hamrLevel, setHamrLevel] = useState(1);
  const [hamrElapsed, setHamrElapsed] = useState(0);
  const [hamrNextIdx, setHamrNextIdx] = useState(0);
  const [hamrFinal, setHamrFinal] = useState(null);
  const hamrStartRef = useRef(null);
  const hamrRafRef = useRef(null);
  const audio = useAudioCtx();

  const presets = [
    { label: "Push-Up Test", seconds: 60, color: "#1E4FD8" },
    { label: "HR Push-Up Test", seconds: 60, color: "#1E4FD8" },
    { label: "Sit-Up Test", seconds: 60, color: "#059A5E" },
    { label: "CL Crunch Test", seconds: 60, color: "#059A5E" },
    { label: "Plank Test", seconds: 220, color: "#D97706" },
    { label: "2-Mile Run", seconds: 1800, color: "#D93A56" },
    { label: "2km Walk", seconds: 1200, color: "#7C3AED" },
    { label: "Rest Interval", seconds: 20, color: "#6B7280" },
  ];

  useEffect(() => {
    if (running) {
      intRef.current = setInterval(() => {
        setSeconds((s) => {
          if (mode === "countdown" && s <= 1) {
            clearInterval(intRef.current);
            setRunning(false);
            return 0;
          }
          return mode === "stopwatch" ? s + 1 : s - 1;
        });
      }, 1000);
    } else clearInterval(intRef.current);
    return () => clearInterval(intRef.current);
  }, [running, mode]);

  const reset = () => {
    setRunning(false);
    clearInterval(intRef.current);
    setSeconds(preset?.seconds || 0);
  };
  const applyPreset = (p) => {
    setPreset(p);
    setSeconds(p.seconds);
    setMode("countdown");
    setRunning(false);
  };

  const hamrReset = () => {
    cancelAnimationFrame(hamrRafRef.current);
    setHamrRunning(false);
    setHamrDone(false);
    setHamrShuttle(0);
    setHamrLevel(1);
    setHamrElapsed(0);
    setHamrNextIdx(0);
    setHamrFinal(null);
    hamrStartRef.current = null;
  };

  const hamrGo = () => {
    if (hamrDone) {
      hamrReset();
      return;
    }
    audio.double();
    setHamrRunning(true);
    hamrStartRef.current = performance.now() - hamrElapsed;
    const tick = (now) => {
      const el = now - hamrStartRef.current;
      setHamrElapsed(el);
      setHamrNextIdx((idx) => {
        let ni = idx;
        while (ni < HAMR_TIMELINE.length && HAMR_TIMELINE[ni].fireAt <= el) {
          const ev = HAMR_TIMELINE[ni];
          setHamrShuttle(ev.shuttle);
          setHamrLevel(ev.level);
          ev.isLevelUp ? audio.levelUp() : audio.beep(880, 0.1, 0.55);
          ni++;
        }
        if (ni >= HAMR_TIMELINE.length) {
          setHamrRunning(false);
          setHamrDone(true);
          audio.levelUp();
          return ni;
        }
        hamrRafRef.current = requestAnimationFrame(tick);
        return ni;
      });
    };
    hamrRafRef.current = requestAnimationFrame(tick);
  };

  const hamrPause = () => {
    setHamrRunning(false);
    cancelAnimationFrame(hamrRafRef.current);
  };
  const hamrStop = () => {
    setHamrFinal(hamrShuttle);
    setHamrRunning(false);
    setHamrDone(true);
    cancelAnimationFrame(hamrRafRef.current);
  };
  useEffect(() => () => cancelAnimationFrame(hamrRafRef.current), []);

  const curLvl = HAMR_LEVELS.find((l) => l[0] === hamrLevel) || HAMR_LEVELS[0];
  const shutsBefore = HAMR_TIMELINE.filter((e) => e.level < hamrLevel).length;
  const shutsThis = hamrShuttle - shutsBefore;
  const lvlPct = shutsThis / curLvl[1];
  const totalPct = hamrShuttle / HAMR_TOTAL;
  const R = 82;
  const CIRC = 2 * Math.PI * R;
  const stdPct =
    mode === "stopwatch"
      ? (seconds % 60) / 60
      : seconds / (preset?.seconds || 60);

  return (
    <div>
      <div
        style={{
          background: T.card,
          padding: "20px 20px 0",
          borderBottom: `1px solid ${T.border}`,
        }}
      >
        <div
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: T.text,
            marginBottom: 16,
          }}
        >
          Timer
        </div>
        <div
          style={{
            display: "flex",
            background: T.bg,
            borderRadius: 12,
            padding: 4,
            marginBottom: -1,
          }}
        >
          {[
            ["standard", "Standard"],
            ["hamr", "HAMR Beep Test"],
          ].map(([m, l]) => (
            <button
              key={m}
              onClick={() => {
                setTimerMode(m);
                m === "standard" ? hamrReset() : reset();
              }}
              style={{
                flex: 1,
                background: timerMode === m ? T.card : "none",
                borderRadius: 10,
                padding: "9px 0",
                fontSize: 13,
                fontWeight: 700,
                color: timerMode === m ? T.text : T.textMuted,
                boxShadow:
                  timerMode === m ? "0 1px 4px rgba(0,0,0,0.08)" : "none",
                transition: "all 0.2s",
              }}
            >
              {l}
            </button>
          ))}
        </div>
      </div>

      {timerMode === "standard" && (
        <div style={{ padding: 16 }}>
          <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
            {["stopwatch", "countdown"].map((m) => (
              <button
                key={m}
                onClick={() => {
                  setMode(m);
                  reset();
                  setPreset(null);
                  setSeconds(0);
                }}
                style={{
                  flex: 1,
                  background: mode === m ? T.accent : T.card,
                  border: `1px solid ${mode === m ? T.accent : T.border}`,
                  borderRadius: 10,
                  padding: "9px 0",
                  fontSize: 12,
                  fontWeight: 700,
                  color: mode === m ? "#fff" : T.textMuted,
                  textTransform: "capitalize",
                }}
              >
                {m}
              </button>
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: 24,
            }}
          >
            <div style={{ position: "relative", width: 200, height: 200 }}>
              <svg
                width={200}
                height={200}
                style={{ transform: "rotate(-90deg)" }}
              >
                <circle
                  cx={100}
                  cy={100}
                  r={R}
                  fill="none"
                  stroke={T.border}
                  strokeWidth={10}
                />
                <circle
                  cx={100}
                  cy={100}
                  r={R}
                  fill="none"
                  stroke={preset?.color || T.accent}
                  strokeWidth={10}
                  strokeDasharray={CIRC}
                  strokeDashoffset={CIRC - stdPct * CIRC}
                  style={{ transition: "stroke-dashoffset 0.9s linear" }}
                  strokeLinecap="round"
                />
              </svg>
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 44,
                    fontWeight: 700,
                    color: T.text,
                    lineHeight: 1,
                    letterSpacing: -1,
                  }}
                >
                  {fmtTime(seconds)}
                </div>
                {preset && (
                  <div
                    style={{
                      fontSize: 12,
                      color: preset.color,
                      fontWeight: 600,
                      marginTop: 4,
                    }}
                  >
                    {preset.label}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: 12,
              justifyContent: "center",
              marginBottom: 24,
            }}
          >
            <button
              onClick={reset}
              style={{
                background: T.card,
                border: `1px solid ${T.border}`,
                borderRadius: 14,
                padding: "14px 18px",
              }}
            >
              <Ic n="reset" s={20} c={T.textMuted} />
            </button>
            <button
              onClick={() => setRunning((r) => !r)}
              style={{
                flex: 1,
                maxWidth: 180,
                background: running ? "#D93A56" : T.accent,
                borderRadius: 14,
                padding: "14px 0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                boxShadow: `0 4px 16px ${running ? "#D93A56" : T.accent}50`,
              }}
            >
              <Ic n={running ? "pause" : "play"} s={20} c="#fff" />
              <span style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>
                {running ? "Pause" : "Start"}
              </span>
            </button>
          </div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: T.text,
              marginBottom: 12,
            }}
          >
            PFRA Presets
          </div>
          <div
            style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}
          >
            {presets.map((p, i) => (
              <button
                key={i}
                onClick={() => applyPreset(p)}
                style={{
                  background:
                    preset?.label === p.label ? `${p.color}15` : T.card,
                  border: `1px solid ${
                    preset?.label === p.label ? p.color : T.border
                  }`,
                  borderRadius: 14,
                  padding: "12px 14px",
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: p.color,
                    marginBottom: 2,
                  }}
                >
                  {fmtTime(p.seconds)}
                </div>
                <div style={{ fontSize: 12, color: T.text }}>{p.label}</div>
              </button>
            ))}
          </div>
        </div>
      )}

      {timerMode === "hamr" && (
        <div style={{ padding: 16 }}>
          <div
            style={{
              background: T.card,
              border: `1px solid ${
                hamrDone ? T.success : hamrRunning ? "#D93A56" : T.border
              }`,
              borderRadius: 20,
              padding: 20,
              marginBottom: 14,
              textAlign: "center",
              boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
            }}
          >
            {hamrDone ? (
              <>
                <div
                  style={{
                    fontSize: 12,
                    color: T.success,
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    textTransform: "uppercase",
                    marginBottom: 8,
                  }}
                >
                  Test Complete
                </div>
                <div
                  style={{
                    fontSize: 72,
                    fontWeight: 700,
                    color: T.text,
                    lineHeight: 1,
                  }}
                >
                  {hamrFinal ?? hamrShuttle}
                </div>
                <div
                  style={{
                    fontSize: 14,
                    color: T.textMuted,
                    marginTop: 4,
                    marginBottom: 6,
                  }}
                >
                  Total Shuttles
                </div>
                <div
                  style={{ fontSize: 20, fontWeight: 700, color: T.success }}
                >
                  Level {hamrLevel}
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    fontSize: 11,
                    color: hamrRunning ? "#D93A56" : T.textMuted,
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    textTransform: "uppercase",
                    marginBottom: 14,
                  }}
                >
                  {hamrRunning
                    ? "Running"
                    : hamrShuttle > 0
                    ? "Paused"
                    : "Ready"}
                </div>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    marginBottom: 14,
                  }}
                >
                  <svg
                    width={190}
                    height={190}
                    style={{ transform: "rotate(-90deg)" }}
                  >
                    <circle
                      cx={95}
                      cy={95}
                      r={R}
                      fill="none"
                      stroke={T.border}
                      strokeWidth={12}
                    />
                    <circle
                      cx={95}
                      cy={95}
                      r={R}
                      fill="none"
                      stroke="#D93A56"
                      strokeWidth={12}
                      strokeDasharray={CIRC}
                      strokeDashoffset={CIRC * (1 - lvlPct)}
                      style={{ transition: "stroke-dashoffset 0.3s ease" }}
                      strokeLinecap="round"
                    />
                  </svg>
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%,-50%)",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 11,
                        color: T.textMuted,
                        fontWeight: 600,
                        marginBottom: 2,
                      }}
                    >
                      LEVEL
                    </div>
                    <div
                      style={{
                        fontSize: 52,
                        fontWeight: 700,
                        color: T.text,
                        lineHeight: 1,
                      }}
                    >
                      {hamrLevel}
                    </div>
                    <div
                      style={{
                        fontSize: 13,
                        color: "#D93A56",
                        fontWeight: 600,
                        marginTop: 2,
                      }}
                    >
                      {shutsThis}/{curLvl[1]}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3,1fr)",
                    gap: 10,
                  }}
                >
                  {[
                    ["Total", hamrShuttle],
                    ["Pace", `${curLvl[2].toFixed(1)}s`],
                    ["Done", `${Math.round(totalPct * 100)}%`],
                  ].map(([l, v]) => (
                    <div
                      key={l}
                      style={{
                        background: T.bg,
                        borderRadius: 10,
                        padding: "10px 6px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 10,
                          color: T.textMuted,
                          marginBottom: 2,
                          fontWeight: 600,
                        }}
                      >
                        {l}
                      </div>
                      <div
                        style={{ fontSize: 20, fontWeight: 700, color: T.text }}
                      >
                        {v}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
          {!hamrDone && (
            <div style={{ marginBottom: 14 }}>
              <div
                style={{
                  height: 6,
                  background: T.border,
                  borderRadius: 3,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    background: "#D93A56",
                    width: `${totalPct * 100}%`,
                    borderRadius: 3,
                    transition: "width 0.3s ease",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 11,
                  color: T.textMuted,
                  marginTop: 4,
                }}
              >
                <span>Progress</span>
                <span>
                  {hamrShuttle} / {HAMR_TOTAL} shuttles
                </span>
              </div>
            </div>
          )}
          <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
            <button
              onClick={hamrReset}
              style={{
                background: T.card,
                border: `1px solid ${T.border}`,
                borderRadius: 14,
                padding: "14px 18px",
              }}
            >
              <Ic n="reset" s={20} c={T.textMuted} />
            </button>
            {!hamrDone && hamrRunning && (
              <button
                onClick={hamrStop}
                style={{
                  background: "#FFF0F3",
                  border: "1px solid #D93A56",
                  borderRadius: 14,
                  padding: "14px 18px",
                  color: "#D93A56",
                  fontSize: 13,
                  fontWeight: 700,
                }}
              >
                Stop
              </button>
            )}
            <button
              onClick={hamrRunning ? hamrPause : hamrGo}
              style={{
                flex: 1,
                background: hamrDone
                  ? "#059A5E"
                  : hamrRunning
                  ? T.card
                  : "#D93A56",
                border: hamrRunning ? `1px solid ${T.border}` : "none",
                borderRadius: 14,
                padding: "14px 0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                boxShadow:
                  hamrRunning || hamrDone ? "none" : "0 4px 16px #D93A5650",
              }}
            >
              <Ic
                n={hamrRunning ? "pause" : "play"}
                s={20}
                c={hamrRunning ? T.text : "#fff"}
              />
              <span
                style={{
                  fontWeight: 700,
                  fontSize: 16,
                  color: hamrRunning ? T.text : "#fff",
                }}
              >
                {hamrDone
                  ? "Reset"
                  : hamrRunning
                  ? "Pause"
                  : hamrShuttle > 0
                  ? "Resume"
                  : "Start"}
              </span>
            </button>
          </div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: T.text,
              marginBottom: 10,
            }}
          >
            Level Reference
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3,1fr)",
              gap: 8,
            }}
          >
            {HAMR_LEVELS.slice(0, 12).map(([lv, sh, iv]) => (
              <div
                key={lv}
                style={{
                  background: hamrLevel === lv ? "#FFF0F3" : T.card,
                  border: `1px solid ${
                    hamrLevel === lv ? "#D93A56" : T.border
                  }`,
                  borderRadius: 12,
                  padding: "10px 10px",
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    color: hamrLevel === lv ? "#D93A56" : T.textMuted,
                    fontWeight: 700,
                    marginBottom: 2,
                  }}
                >
                  Lvl {lv}
                </div>
                <div style={{ fontSize: 12, color: T.text, fontWeight: 600 }}>
                  {sh} shuttles
                </div>
                <div style={{ fontSize: 11, color: T.textMuted }}>
                  {iv.toFixed(1)}s
                </div>
              </div>
            ))}
          </div>
          <div
            style={{
              marginTop: 12,
              background: T.card,
              border: `1px solid ${T.border}`,
              borderRadius: 14,
              padding: "12px 14px",
            }}
          >
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: T.accent,
                letterSpacing: 0.4,
                textTransform: "uppercase",
                marginBottom: 4,
              }}
            >
              How It Works
            </div>
            <div style={{ fontSize: 12, color: T.textMuted, lineHeight: 1.7 }}>
              Run 20m on each beep. Press Stop when you can no longer reach the
              line in time — your shuttle count is your HAMR score.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ScoresTab({ T, profile, savedScores, setSavedScores }) {
  const [view, setView] = useState("calc");
  const [form, setForm] = useState({
    gender: profile.gender || "M",
    ageGroup: "Under 25",
    pushType: "pushup",
    pushups: "",
    hrpushups: "",
    coreType: "situp",
    situps: "",
    clrc: "",
    cardioType: "run",
    runMin: "",
    runSec: "",
    hamrShuttles: "",
    planks: "",
    waist: "",
    height: "",
    date: new Date().toISOString().slice(0, 10),
  });
  const [result, setResult] = useState(null);
  const upd = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const calc = () => {
    const g = form.gender,
      ag = form.ageGroup;
    const pushPts =
      form.pushType === "pushup"
        ? scoreFromTable(PUSHUP_SCORES, parseInt(form.pushups) || 0, g, ag)
        : scoreFromTable(HRPU_SCORES, parseInt(form.hrpushups) || 0, g, ag);
    const sitPts =
      form.coreType === "situp"
        ? scoreFromTable(SITUP_SCORES, parseInt(form.situps) || 0, g, ag)
        : scoreFromTable(CLRC_SCORES, parseInt(form.clrc) || 0, g, ag);
    const plankSec = parseInt(form.planks) || 0;
    const plankPts =
      plankSec >= 220 ? 15 : Math.max(2.5, 15 - ((220 - plankSec) / 5) * 0.5);
    const runPts =
      form.cardioType === "run"
        ? scoreRun(
            (parseInt(form.runMin) || 0) * 60 + (parseInt(form.runSec) || 0),
            g,
            ag
          )
        : scoreHAMR(parseInt(form.hamrShuttles) || 0, g, ag);
    const ratio =
      form.waist && form.height
        ? parseFloat(form.waist) / parseFloat(form.height)
        : null;
    const whtrPts = ratio ? scoreWHtR(ratio) : 0;
    const total = Math.min(100, pushPts + sitPts + runPts + whtrPts);
    const pushLabel = form.pushType === "pushup" ? "Push-Up" : "HR Push-Up";
    const coreLabel = form.coreType === "situp" ? "Sit-Up" : "CL Rev. Crunch";
    const cardioLabel = form.cardioType === "run" ? "2-Mile Run" : "HAMR";
    setResult({
      pushPts,
      sitPts,
      plankPts,
      runPts,
      whtrPts,
      total,
      ratio,
      pushLabel,
      coreLabel,
      cardioLabel,
    });
  };

  const save = () => {
    if (!result) return;
    setSavedScores([
      ...savedScores,
      {
        ...result,
        date: form.date,
        gender: form.gender,
        ageGroup: form.ageGroup,
      },
    ]);
    setResult(null);
    setForm((f) => ({
      ...f,
      pushups: "",
      hrpushups: "",
      situps: "",
      clrc: "",
      planks: "",
      runMin: "",
      runSec: "",
      hamrShuttles: "",
      waist: "",
      height: "",
    }));
    setView("history");
  };

  const inp = {
    width: "100%",
    background: T.bg,
    border: `1px solid ${T.border}`,
    borderRadius: 10,
    padding: "12px 14px",
    color: T.text,
    fontSize: 14,
    fontWeight: 500,
  };
  const lbl = {
    fontSize: 12,
    fontWeight: 700,
    color: T.textMuted,
    letterSpacing: 0.3,
    marginBottom: 6,
    display: "block",
  };

  const Pill = ({ opts, value, onChange }) => (
    <div
      style={{
        display: "flex",
        background: T.bg,
        borderRadius: 10,
        padding: 4,
        marginBottom: 12,
      }}
    >
      {opts.map((o) => (
        <button
          key={o.v}
          onClick={() => onChange(o.v)}
          style={{
            flex: 1,
            background: value === o.v ? T.accent : "none",
            borderRadius: 8,
            padding: "8px 6px",
            fontSize: 11,
            fontWeight: 700,
            color: value === o.v ? "#fff" : T.textMuted,
            transition: "all 0.15s",
          }}
        >
          {o.l}
        </button>
      ))}
    </div>
  );

  const SH = ({ title, color }) => (
    <div
      style={{
        fontSize: 13,
        fontWeight: 700,
        color,
        marginBottom: 10,
        marginTop: 2,
      }}
    >
      {title}
    </div>
  );

  return (
    <div>
      <div
        style={{
          background: T.card,
          padding: "20px 20px 0",
          borderBottom: `1px solid ${T.border}`,
        }}
      >
        <div
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: T.text,
            marginBottom: 16,
          }}
        >
          PFRA Calculator
        </div>
        <div
          style={{
            display: "flex",
            background: T.bg,
            borderRadius: 12,
            padding: 4,
            marginBottom: -1,
          }}
        >
          {[
            ["calc", "Calculate"],
            ["history", "History"],
          ].map(([v, l]) => (
            <button
              key={v}
              onClick={() => setView(v)}
              style={{
                flex: 1,
                background: view === v ? T.card : "none",
                borderRadius: 10,
                padding: "9px 0",
                fontSize: 13,
                fontWeight: 700,
                color: view === v ? T.text : T.textMuted,
                boxShadow: view === v ? "0 1px 4px rgba(0,0,0,0.08)" : "none",
              }}
            >
              {l}
            </button>
          ))}
        </div>
      </div>

      {view === "history" && (
        <div style={{ padding: 16 }}>
          {savedScores.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: "60px 20px",
                color: T.textMuted,
              }}
            >
              <div
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: T.text,
                  marginBottom: 4,
                }}
              >
                No scores saved yet
              </div>
              <div style={{ fontSize: 13 }}>
                Calculate and save your first PFRA score
              </div>
            </div>
          ) : (
            [...savedScores].reverse().map((s, i) => {
              const sc =
                s.total >= 90
                  ? "#059A5E"
                  : s.total >= 75
                  ? "#D97706"
                  : "#D93A56";
              return (
                <div
                  key={i}
                  style={{
                    background: T.card,
                    border: `1px solid ${T.border}`,
                    borderRadius: 18,
                    padding: 18,
                    marginBottom: 12,
                    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: 12,
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: 52,
                          fontWeight: 700,
                          color: T.text,
                          lineHeight: 1,
                        }}
                      >
                        {s.total.toFixed(1)}
                      </div>
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 700,
                          color: sc,
                          marginTop: 4,
                        }}
                      >
                        {s.total >= 90
                          ? "Excellent"
                          : s.total >= 75
                          ? "Satisfactory"
                          : "Unsatisfactory"}
                      </div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ fontSize: 12, color: T.textMuted }}>
                        {s.date}
                      </div>
                      <div
                        style={{
                          fontSize: 11,
                          color: T.textMuted,
                          marginTop: 2,
                        }}
                      >
                        {s.gender === "M" ? "Male" : "Female"} · {s.ageGroup}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      height: 6,
                      background: T.bg,
                      borderRadius: 3,
                      marginBottom: 12,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        height: "100%",
                        width: `${s.total}%`,
                        background: sc,
                        borderRadius: 3,
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4,1fr)",
                      gap: 8,
                    }}
                  >
                    {[
                      [s.pushLabel || "Push-Up", s.pushPts, "#1E4FD8"],
                      [s.coreLabel || "Core", s.sitPts, "#059A5E"],
                      [s.cardioLabel || "Run", s.runPts, "#D93A56"],
                      ["WHtR", s.whtrPts, "#7C3AED"],
                    ].map(([label, pts, color]) => (
                      <div
                        key={label}
                        style={{
                          background: T.bg,
                          borderRadius: 10,
                          padding: "8px 6px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            fontSize: 9,
                            color: T.textMuted,
                            fontWeight: 600,
                            marginBottom: 2,
                          }}
                        >
                          {label}
                        </div>
                        <div style={{ fontSize: 18, fontWeight: 700, color }}>
                          {typeof pts === "number" ? pts.toFixed(1) : pts}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })
          )}
        </div>
      )}

      {view === "calc" && (
        <div style={{ padding: 16 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 12,
              marginBottom: 14,
            }}
          >
            <div>
              <label style={lbl}>Gender</label>
              <select
                value={form.gender}
                onChange={(e) => upd("gender", e.target.value)}
                style={inp}
              >
                <option value="M">Male</option>
                <option value="F">Female</option>
              </select>
            </div>
            <div>
              <label style={lbl}>Age Group</label>
              <select
                value={form.ageGroup}
                onChange={(e) => upd("ageGroup", e.target.value)}
                style={inp}
              >
                {AGE_GROUPS.map((a) => (
                  <option key={a} value={a}>
                    {a}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div
            style={{
              background: T.card,
              border: `1px solid ${T.border}`,
              borderRadius: 16,
              padding: 16,
              marginBottom: 12,
            }}
          >
            <SH title="Upper Body" color="#1E4FD8" />
            <Pill
              opts={[
                { v: "pushup", l: "Push-Up" },
                { v: "hrpushup", l: "Hand Release" },
              ]}
              value={form.pushType}
              onChange={(v) => upd("pushType", v)}
            />
            <label style={lbl}>
              {form.pushType === "pushup" ? "Push-Up Reps" : "HR Push-Up Reps"}
            </label>
            <input
              type="number"
              value={form.pushType === "pushup" ? form.pushups : form.hrpushups}
              onChange={(e) =>
                upd(
                  form.pushType === "pushup" ? "pushups" : "hrpushups",
                  e.target.value
                )
              }
              style={inp}
              placeholder="e.g. 45"
            />
          </div>
          <div
            style={{
              background: T.card,
              border: `1px solid ${T.border}`,
              borderRadius: 16,
              padding: 16,
              marginBottom: 12,
            }}
          >
            <SH title="Core" color="#059A5E" />
            <Pill
              opts={[
                { v: "situp", l: "Sit-Up" },
                { v: "clrc", l: "Cross-Leg Crunch" },
              ]}
              value={form.coreType}
              onChange={(v) => upd("coreType", v)}
            />
            <label style={lbl}>
              {form.coreType === "situp"
                ? "Sit-Up Reps"
                : "CL Reverse Crunch Reps"}
            </label>
            <input
              type="number"
              value={form.coreType === "situp" ? form.situps : form.clrc}
              onChange={(e) =>
                upd(
                  form.coreType === "situp" ? "situps" : "clrc",
                  e.target.value
                )
              }
              style={inp}
              placeholder="e.g. 50"
            />
          </div>
          <div
            style={{
              background: T.card,
              border: `1px solid ${T.border}`,
              borderRadius: 16,
              padding: 16,
              marginBottom: 12,
            }}
          >
            <SH title="Forearm Plank" color="#D97706" />
            <label style={lbl}>Hold Time (seconds)</label>
            <input
              type="number"
              value={form.planks}
              onChange={(e) => upd("planks", e.target.value)}
              style={inp}
              placeholder="e.g. 180"
            />
          </div>
          <div
            style={{
              background: T.card,
              border: `1px solid ${T.border}`,
              borderRadius: 16,
              padding: 16,
              marginBottom: 12,
            }}
          >
            <SH title="Cardiorespiratory" color="#D93A56" />
            <Pill
              opts={[
                { v: "run", l: "2-Mile Run" },
                { v: "hamr", l: "HAMR Shuttles" },
              ]}
              value={form.cardioType}
              onChange={(v) => upd("cardioType", v)}
            />
            {form.cardioType === "run" ? (
              <>
                <label style={lbl}>Run Time</label>
                <div style={{ display: "flex", gap: 10 }}>
                  <input
                    type="number"
                    value={form.runMin}
                    onChange={(e) => upd("runMin", e.target.value)}
                    style={{ ...inp, flex: 1 }}
                    placeholder="Min"
                  />
                  <input
                    type="number"
                    value={form.runSec}
                    onChange={(e) => upd("runSec", e.target.value)}
                    style={{ ...inp, flex: 1 }}
                    placeholder="Sec"
                  />
                </div>
              </>
            ) : (
              <>
                <label style={lbl}>Shuttles Completed</label>
                <input
                  type="number"
                  value={form.hamrShuttles}
                  onChange={(e) => upd("hamrShuttles", e.target.value)}
                  style={inp}
                  placeholder="e.g. 65"
                />
              </>
            )}
          </div>
          <div
            style={{
              background: T.card,
              border: `1px solid ${T.border}`,
              borderRadius: 16,
              padding: 16,
              marginBottom: 12,
            }}
          >
            <SH title="Body Composition (WHtR)" color="#7C3AED" />
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 10,
              }}
            >
              <div>
                <label style={lbl}>Waist (in)</label>
                <input
                  type="number"
                  step="0.1"
                  value={form.waist}
                  onChange={(e) => upd("waist", e.target.value)}
                  style={inp}
                  placeholder="32"
                />
              </div>
              <div>
                <label style={lbl}>Height (in)</label>
                <input
                  type="number"
                  step="0.1"
                  value={form.height}
                  onChange={(e) => upd("height", e.target.value)}
                  style={inp}
                  placeholder="68"
                />
              </div>
            </div>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={lbl}>Assessment Date</label>
            <input
              type="date"
              value={form.date}
              onChange={(e) => upd("date", e.target.value)}
              style={inp}
            />
          </div>
          <button
            onClick={calc}
            style={{
              width: "100%",
              background: T.accent,
              color: "#fff",
              borderRadius: 16,
              padding: "16px 0",
              fontSize: 16,
              fontWeight: 700,
              marginBottom: 16,
              boxShadow: `0 4px 16px ${T.accent}50`,
            }}
          >
            Calculate Score
          </button>
          {result && (
            <div
              style={{
                background: T.card,
                border: `1px solid ${T.border}`,
                borderRadius: 20,
                padding: 20,
                marginBottom: 8,
              }}
            >
              <div style={{ textAlign: "center", marginBottom: 16 }}>
                <div
                  style={{
                    fontSize: 72,
                    fontWeight: 700,
                    color: T.text,
                    lineHeight: 1,
                  }}
                >
                  {result.total.toFixed(1)}
                </div>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 700,
                    color:
                      result.total >= 90
                        ? "#059A5E"
                        : result.total >= 75
                        ? "#D97706"
                        : "#D93A56",
                    marginTop: 4,
                  }}
                >
                  {result.total >= 90
                    ? "Excellent"
                    : result.total >= 75
                    ? "Satisfactory"
                    : "Unsatisfactory"}
                </div>
              </div>
              <div
                style={{
                  height: 8,
                  background: T.bg,
                  borderRadius: 4,
                  marginBottom: 16,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: `${result.total}%`,
                    background:
                      result.total >= 90
                        ? "#059A5E"
                        : result.total >= 75
                        ? "#D97706"
                        : "#D93A56",
                    borderRadius: 4,
                  }}
                />
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 10,
                  marginBottom: 16,
                }}
              >
                {[
                  [result.pushLabel, result.pushPts, "#1E4FD8"],
                  [result.coreLabel, result.sitPts, "#059A5E"],
                  [result.cardioLabel, result.runPts, "#D93A56"],
                  ["WHtR", result.whtrPts, "#7C3AED"],
                ].map(([l, p, c]) => (
                  <div
                    key={l}
                    style={{
                      background: T.bg,
                      borderRadius: 12,
                      padding: "12px 14px",
                      borderLeft: `3px solid ${c}`,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 11,
                        color: T.textMuted,
                        fontWeight: 600,
                        marginBottom: 2,
                      }}
                    >
                      {l}
                    </div>
                    <div
                      style={{ fontSize: 24, fontWeight: 700, color: T.text }}
                    >
                      {typeof p === "number" ? p.toFixed(1) : p}
                    </div>
                  </div>
                ))}
              </div>
              {result.ratio && (
                <div
                  style={{
                    background: T.bg,
                    borderRadius: 10,
                    padding: "10px 14px",
                    marginBottom: 14,
                    fontSize: 12,
                    color: T.textMuted,
                  }}
                >
                  WHtR: {result.ratio.toFixed(3)} —{" "}
                  {result.ratio <= 0.49
                    ? "Low Risk"
                    : result.ratio <= 0.54
                    ? "Moderate Risk"
                    : "High Risk"}
                </div>
              )}
              <button
                onClick={save}
                style={{
                  width: "100%",
                  background: "#059A5E",
                  color: "#fff",
                  borderRadius: 14,
                  padding: "14px 0",
                  fontSize: 15,
                  fontWeight: 700,
                  boxShadow: "0 4px 16px #059A5E40",
                }}
              >
                Save Score
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function CommunityTab({
  T,
  profile,
  notifications,
  setNotifications,
  isPro,
  friends,
  setFriends,
  userRanks,
  savedScores,
}) {
  const [view, setView] = useState("feed");
  const [msg, setMsg] = useState("");
  const [newFriendName, setNewFriendName] = useState("");
  const [posts, setPosts] = useState([
    {
      id: 1,
      author: "MSgt Rivera",
      rank: "MSgt",
      text: "Hit a new PR on the 2-mile today — 13:22. Consistent interval work pays off.",
      time: "1h ago",
      likes: 14,
      liked: false,
    },
    {
      id: 2,
      author: "SrA Chen",
      rank: "SrA",
      text: "Anyone else doing the 8-week push-up program? Week 3 and already up 12 reps.",
      time: "3h ago",
      likes: 9,
      liked: false,
    },
    {
      id: 3,
      author: "SSgt Williams",
      rank: "SSgt",
      text: "Tip: Stop 2 reps before failure on training sets. You recover faster and hit more total volume.",
      time: "6h ago",
      likes: 21,
      liked: true,
    },
    {
      id: 4,
      author: "A1C Patel",
      rank: "A1C",
      text: "Aced my PFRA today — 94.5! Goals tab workouts are legit.",
      time: "1d ago",
      likes: 33,
      liked: false,
    },
  ]);

  // Mock leaderboard data — replace with real backend later
  const leaderboards = {
    local: {
      title: "Local",
      subtitle: profile.unit || "Your Unit",
      total: 124,
      entries: [
        { rank: 1, name: "TSgt Martinez", score: 96.5, badge: "gold" },
        { rank: 2, name: "SSgt Williams", score: 95.0, badge: "silver" },
        { rank: 3, name: "MSgt Rivera", score: 92.5, badge: "bronze" },
        { rank: 4, name: "Capt Johnson", score: 91.0 },
        { rank: 5, name: "SrA Chen", score: 88.0 },
      ],
    },
    regional: {
      title: "Regional",
      subtitle: "Air Combat Command",
      total: 12480,
      entries: [
        { rank: 1, name: "Maj Anderson", score: 99.0, badge: "gold" },
        { rank: 2, name: "TSgt Park", score: 98.5, badge: "silver" },
        { rank: 3, name: "SSgt Lee", score: 98.0, badge: "bronze" },
        { rank: 4, name: "Capt Brown", score: 97.5 },
        { rank: 5, name: "SrA Davis", score: 97.0 },
      ],
    },
    world: {
      title: "Worldwide",
      subtitle: "All Air Force",
      total: 342750,
      entries: [
        { rank: 1, name: "1Lt Kowalski", score: 100.0, badge: "gold" },
        { rank: 2, name: "MSgt Tanaka", score: 100.0, badge: "silver" },
        { rank: 3, name: "Capt Hassan", score: 99.5, badge: "bronze" },
        { rank: 4, name: "SSgt Müller", score: 99.5 },
        { rank: 5, name: "TSgt O'Brien", score: 99.0 },
      ],
    },
  };

  const unread = notifications.filter((n) => !n.read).length;
  const likePost = (id) =>
    setPosts((ps) =>
      ps.map((p) =>
        p.id === id
          ? {
              ...p,
              likes: p.liked ? p.likes - 1 : p.likes + 1,
              liked: !p.liked,
            }
          : p
      )
    );
  const sendPost = () => {
    if (!msg.trim()) return;
    setPosts((ps) => [
      {
        id: Date.now(),
        author: profile.name || "You",
        rank: profile.rank || "Amn",
        text: msg,
        time: "now",
        likes: 0,
        liked: false,
      },
      ...ps,
    ]);
    setMsg("");
  };

  const addFriend = () => {
    const name = newFriendName.trim();
    if (!name) return;
    setFriends((fs) => [
      ...fs,
      { id: Date.now(), name, status: "Pending", score: 0 },
    ]);
    setNewFriendName("");
  };
  const removeFriend = (id) =>
    setFriends((fs) => fs.filter((f) => f.id !== id));

  const TabPill = ({ vKey, label }) => (
    <button
      onClick={() => {
        setView(vKey);
        if (vKey === "notifications")
          setNotifications((n) => n.map((x) => ({ ...x, read: true })));
      }}
      style={{
        flex: 1,
        background: view === vKey ? T.card : "none",
        borderRadius: 10,
        padding: "9px 2px",
        fontSize: 11,
        fontWeight: 700,
        color: view === vKey ? T.text : T.textMuted,
        boxShadow: view === vKey ? "0 1px 4px rgba(0,0,0,0.08)" : "none",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </button>
  );

  const badgeColor = (b) =>
    b === "gold"
      ? "#F59E0B"
      : b === "silver"
      ? "#9CA3AF"
      : b === "bronze"
      ? "#CD7F32"
      : null;

  return (
    <div>
      <div
        style={{
          background: T.card,
          padding: "20px 16px 0",
          borderBottom: `1px solid ${T.border}`,
        }}
      >
        <div
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: T.text,
            marginBottom: 14,
          }}
        >
          Squadron
        </div>
        <div
          style={{
            display: "flex",
            background: T.bg,
            borderRadius: 12,
            padding: 4,
            marginBottom: -1,
            gap: 2,
          }}
        >
          <TabPill vKey="feed" label="Feed" />
          <TabPill vKey="friends" label="Friends" />
          <TabPill vKey="ranks" label="Ranks" />
          <TabPill
            vKey="notifications"
            label={`Alerts${unread > 0 ? ` (${unread})` : ""}`}
          />
        </div>
      </div>
      <div style={{ padding: 16 }}>
        {view === "feed" && (
          <>
            <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
              <input
                value={msg}
                onChange={(e) => setMsg(e.target.value)}
                placeholder="Share a training update..."
                onKeyDown={(e) => e.key === "Enter" && sendPost()}
                style={{
                  flex: 1,
                  background: T.bg,
                  border: `1px solid ${T.border}`,
                  borderRadius: 12,
                  padding: "12px 14px",
                  color: T.text,
                  fontSize: 13,
                }}
              />
              <button
                onClick={sendPost}
                style={{
                  background: T.accent,
                  borderRadius: 12,
                  padding: "0 16px",
                }}
              >
                <Ic n="send" s={18} c="#fff" />
              </button>
            </div>
            {posts.map((p) => (
              <div
                key={p.id}
                style={{
                  background: T.card,
                  border: `1px solid ${T.border}`,
                  borderRadius: 18,
                  padding: 16,
                  marginBottom: 12,
                  boxShadow: "0 1px 8px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    marginBottom: 10,
                  }}
                >
                  <div
                    style={{
                      width: 38,
                      height: 38,
                      borderRadius: 19,
                      background: T.accent,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <span
                      style={{ color: "#fff", fontSize: 14, fontWeight: 700 }}
                    >
                      {p.author[0]}
                    </span>
                  </div>
                  <div>
                    <div
                      style={{ fontSize: 13, fontWeight: 700, color: T.text }}
                    >
                      {p.rank} {p.author}
                    </div>
                    <div style={{ fontSize: 11, color: T.textMuted }}>
                      {p.time}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    fontSize: 14,
                    color: T.text,
                    lineHeight: 1.65,
                    marginBottom: 12,
                  }}
                >
                  {p.text}
                </div>
                <button
                  onClick={() => likePost(p.id)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    color: p.liked ? "#D93A56" : T.textMuted,
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  <Ic
                    n="heart"
                    s={16}
                    c={p.liked ? "#D93A56" : T.textMuted}
                    fill={p.liked ? "#D93A56" : "none"}
                  />
                  {p.likes}
                </button>
              </div>
            ))}
          </>
        )}

        {view === "friends" && (
          <>
            {/* Add friend input */}
            <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
              <input
                value={newFriendName}
                onChange={(e) => setNewFriendName(e.target.value)}
                placeholder="Search by rank, name, or unit..."
                onKeyDown={(e) => e.key === "Enter" && addFriend()}
                style={{
                  flex: 1,
                  background: T.bg,
                  border: `1px solid ${T.border}`,
                  borderRadius: 12,
                  padding: "12px 14px",
                  color: T.text,
                  fontSize: 13,
                }}
              />
              <button
                onClick={addFriend}
                disabled={!newFriendName.trim()}
                style={{
                  background: newFriendName.trim() ? T.accent : T.border,
                  borderRadius: 12,
                  padding: "0 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <Ic n="plus" s={18} c="#fff" />
                <span style={{ color: "#fff", fontSize: 13, fontWeight: 700 }}>
                  Add
                </span>
              </button>
            </div>
            <div
              style={{
                fontSize: 12,
                color: T.textMuted,
                marginBottom: 10,
                fontWeight: 600,
              }}
            >
              {friends.length} {friends.length === 1 ? "friend" : "friends"}
            </div>
            {friends.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px 20px",
                  color: T.textMuted,
                }}
              >
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: T.text,
                    marginBottom: 4,
                  }}
                >
                  No friends yet
                </div>
                <div style={{ fontSize: 13 }}>
                  Add fellow Airmen to compare scores and train together
                </div>
              </div>
            ) : (
              friends.map((f) => (
                <div
                  key={f.id}
                  style={{
                    background: T.card,
                    border: `1px solid ${T.border}`,
                    borderRadius: 16,
                    padding: 14,
                    marginBottom: 10,
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <div
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 22,
                      background: `linear-gradient(135deg, ${T.accent}, ${T.accentDark})`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <span
                      style={{ color: "#fff", fontSize: 16, fontWeight: 700 }}
                    >
                      {f.name[0]}
                    </span>
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 700,
                        color: T.text,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {f.name}
                    </div>
                    <div
                      style={{ fontSize: 12, color: T.textMuted, marginTop: 2 }}
                    >
                      {f.status}
                    </div>
                  </div>
                  <div style={{ textAlign: "right", marginRight: 4 }}>
                    <div
                      style={{
                        fontSize: 22,
                        fontWeight: 700,
                        color: f.score > 0 ? T.accent : T.textMuted,
                      }}
                    >
                      {f.score > 0 ? f.score : "—"}
                    </div>
                    <div style={{ fontSize: 10, color: T.textMuted }}>
                      {f.score > 0 ? "Last PFRA" : "No score"}
                    </div>
                  </div>
                  <button
                    onClick={() => removeFriend(f.id)}
                    style={{
                      background: `${T.danger}12`,
                      border: `1px solid ${T.danger}30`,
                      borderRadius: 10,
                      padding: 8,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Ic n="trash" s={16} c={T.danger} />
                  </button>
                </div>
              ))
            )}
            {!isPro && (
              <div
                style={{
                  background: T.card,
                  border: `1px dashed ${T.accent}`,
                  borderRadius: 16,
                  padding: 20,
                  textAlign: "center",
                  marginTop: 8,
                }}
              >
                <Ic n="lock" s={22} c={T.accent} />
                <div style={{ fontSize: 12, color: T.textMuted, marginTop: 8 }}>
                  Pro: unlimited friends + unit leaderboards
                </div>
              </div>
            )}
          </>
        )}

        {view === "ranks" && (
          <>
            {/* User's own ranks summary card */}
            <div
              style={{
                background: `linear-gradient(135deg, ${T.hero1}, ${T.hero2})`,
                borderRadius: 20,
                padding: 18,
                marginBottom: 18,
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: -30,
                  right: -30,
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.04)",
                }}
              />
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "rgba(255,255,255,0.65)",
                  letterSpacing: 0.5,
                  textTransform: "uppercase",
                  marginBottom: 10,
                }}
              >
                Your Standing
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3,1fr)",
                  gap: 10,
                }}
              >
                {[
                  ["Local", userRanks.local, "pin"],
                  ["Regional", userRanks.regional, "award"],
                  ["Worldwide", userRanks.world, "globe"],
                ].map(([label, rank, icon]) => (
                  <div
                    key={label}
                    style={{
                      background: "rgba(255,255,255,0.10)",
                      borderRadius: 14,
                      padding: "12px 8px",
                      textAlign: "center",
                      border: "1px solid rgba(255,255,255,0.12)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: 6,
                      }}
                    >
                      <Ic n={icon} s={16} c="rgba(255,255,255,0.7)" />
                    </div>
                    <div
                      style={{
                        fontSize: 10,
                        color: "rgba(255,255,255,0.6)",
                        fontWeight: 600,
                        marginBottom: 2,
                      }}
                    >
                      {label}
                    </div>
                    <div
                      style={{
                        fontSize: 18,
                        fontWeight: 700,
                        color: "#fff",
                        lineHeight: 1,
                      }}
                    >
                      {rank !== null ? `#${rank.toLocaleString()}` : "—"}
                    </div>
                  </div>
                ))}
              </div>
              {userRanks.local === null && (
                <div
                  style={{
                    marginTop: 12,
                    fontSize: 12,
                    color: "rgba(255,255,255,0.6)",
                    textAlign: "center",
                  }}
                >
                  Save a PFRA score to see your ranking
                </div>
              )}
            </div>

            {/* Three leaderboard sections */}
            {["local", "regional", "world"].map((key) => {
              const lb = leaderboards[key];
              const iconName =
                key === "local"
                  ? "pin"
                  : key === "regional"
                  ? "award"
                  : "globe";
              return (
                <div
                  key={key}
                  style={{
                    background: T.card,
                    border: `1px solid ${T.border}`,
                    borderRadius: 18,
                    padding: 16,
                    marginBottom: 14,
                    boxShadow: "0 1px 8px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 14,
                    }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <div
                        style={{
                          background: `${T.accent}15`,
                          borderRadius: 10,
                          width: 36,
                          height: 36,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Ic n={iconName} s={18} c={T.accent} />
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: 15,
                            fontWeight: 700,
                            color: T.text,
                          }}
                        >
                          {lb.title}
                        </div>
                        <div style={{ fontSize: 11, color: T.textMuted }}>
                          {lb.subtitle}
                        </div>
                      </div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ fontSize: 11, color: T.textMuted }}>
                        Total
                      </div>
                      <div
                        style={{ fontSize: 13, fontWeight: 700, color: T.text }}
                      >
                        {lb.total.toLocaleString()}
                      </div>
                    </div>
                  </div>
                  {lb.entries.map((e) => {
                    const bc = badgeColor(e.badge);
                    return (
                      <div
                        key={e.rank}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                          padding: "10px 0",
                          borderBottom:
                            e.rank < lb.entries.length
                              ? `1px solid ${T.border}`
                              : "none",
                        }}
                      >
                        <div
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: 16,
                            background: bc ? `${bc}20` : T.bg,
                            border: bc
                              ? `2px solid ${bc}`
                              : `1px solid ${T.border}`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <span
                            style={{
                              fontSize: 13,
                              fontWeight: 700,
                              color: bc || T.textMuted,
                            }}
                          >
                            {e.rank}
                          </span>
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              fontSize: 14,
                              fontWeight: 600,
                              color: T.text,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {e.name}
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: e.score >= 90 ? T.success : T.accent,
                          }}
                        >
                          {e.score.toFixed(1)}
                        </div>
                      </div>
                    );
                  })}
                  {userRanks[key] !== null && userRanks[key] > 5 && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        padding: "10px 0",
                        marginTop: 6,
                        background: `${T.accent}08`,
                        borderRadius: 10,
                        paddingLeft: 8,
                        paddingRight: 8,
                      }}
                    >
                      <div
                        style={{
                          width: 32,
                          height: 32,
                          borderRadius: 16,
                          background: T.accent,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <span
                          style={{
                            fontSize: 11,
                            fontWeight: 700,
                            color: "#fff",
                          }}
                        >
                          {userRanks[key] > 999
                            ? `${(userRanks[key] / 1000).toFixed(0)}k`
                            : userRanks[key]}
                        </span>
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontSize: 13,
                            fontWeight: 700,
                            color: T.accent,
                          }}
                        >
                          You
                        </div>
                        <div style={{ fontSize: 10, color: T.textMuted }}>
                          Rank #{userRanks[key].toLocaleString()}
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: 16,
                          fontWeight: 700,
                          color: T.accent,
                        }}
                      >
                        {savedScores.length > 0
                          ? savedScores[savedScores.length - 1].total.toFixed(1)
                          : "—"}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}

            {!isPro && (
              <div
                style={{
                  background: T.card,
                  border: `1px dashed ${T.accent}`,
                  borderRadius: 16,
                  padding: 18,
                  textAlign: "center",
                  marginTop: 4,
                }}
              >
                <Ic n="lock" s={22} c={T.accent} />
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: T.text,
                    marginTop: 8,
                    marginBottom: 4,
                  }}
                >
                  Full Leaderboard Access
                </div>
                <div style={{ fontSize: 12, color: T.textMuted }}>
                  Pro members see complete rankings and filter by component
                </div>
              </div>
            )}
          </>
        )}

        {view === "notifications" &&
          (notifications.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: "40px 20px",
                color: T.textMuted,
              }}
            >
              <div
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: T.text,
                  marginBottom: 4,
                }}
              >
                No alerts
              </div>
              <div style={{ fontSize: 13 }}>You're all caught up.</div>
            </div>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 12,
                }}
              >
                <div
                  style={{ fontSize: 12, color: T.textMuted, fontWeight: 600 }}
                >
                  {notifications.length}{" "}
                  {notifications.length === 1 ? "alert" : "alerts"}
                </div>
                <button
                  onClick={() => setNotifications([])}
                  style={{
                    background: `${T.danger}12`,
                    border: `1px solid ${T.danger}30`,
                    borderRadius: 10,
                    padding: "6px 12px",
                    color: T.danger,
                    fontSize: 12,
                    fontWeight: 700,
                  }}
                >
                  Clear All
                </button>
              </div>
              {notifications.map((n) => (
                <div
                  key={n.id}
                  style={{
                    background: n.read ? T.card : `${T.accent}10`,
                    border: `1px solid ${n.read ? T.border : T.accent}`,
                    borderRadius: 16,
                    padding: 14,
                    marginBottom: 10,
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 12,
                  }}
                >
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 4,
                        gap: 8,
                      }}
                    >
                      <span
                        style={{ fontSize: 13, fontWeight: 700, color: T.text }}
                      >
                        {n.from}
                      </span>
                      <span
                        style={{
                          fontSize: 11,
                          color: T.textMuted,
                          flexShrink: 0,
                        }}
                      >
                        {n.time}
                      </span>
                    </div>
                    <div style={{ fontSize: 13, color: T.textMuted }}>
                      {n.msg}
                    </div>
                  </div>
                  <button
                    onClick={() =>
                      setNotifications((ns) => ns.filter((x) => x.id !== n.id))
                    }
                    style={{
                      background: `${T.danger}12`,
                      border: `1px solid ${T.danger}30`,
                      borderRadius: 10,
                      padding: 8,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Ic n="trash" s={14} c={T.danger} />
                  </button>
                </div>
              ))}
            </>
          ))}
      </div>
    </div>
  );
}

function ProfileTab({
  T,
  profile,
  setProfile,
  theme,
  setTheme,
  isPro,
  setIsPro,
  userRanks,
}) {
  const upd = (k, v) => setProfile((p) => ({ ...p, [k]: v }));
  const inp = {
    width: "100%",
    background: T.bg,
    border: `1px solid ${T.border}`,
    borderRadius: 12,
    padding: "12px 14px",
    color: T.text,
    fontSize: 14,
    fontWeight: 500,
  };
  const lbl = {
    fontSize: 12,
    fontWeight: 700,
    color: T.textMuted,
    letterSpacing: 0.3,
    marginBottom: 6,
    display: "block",
  };
  const ranks = [
    "AB",
    "Amn",
    "A1C",
    "SrA",
    "SSgt",
    "TSgt",
    "MSgt",
    "SMSgt",
    "CMSgt",
    "2Lt",
    "1Lt",
    "Capt",
    "Maj",
    "LtCol",
    "Col",
  ];
  const displayName = profile.rank
    ? `${profile.rank} ${profile.name || ""}`.trim()
    : profile.name || "Your Profile";
  const fileInputRef = useRef(null);

  const handleAvatarUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) return;
    if (file.size > 5 * 1024 * 1024) {
      alert("Image too large. Please use one under 5MB.");
      return;
    }
    const reader = new FileReader();
    reader.onload = () => upd("avatar", reader.result);
    reader.readAsDataURL(file);
  };

  const removeAvatar = () => upd("avatar", "");

  return (
    <div>
      <div
        style={{
          background: `linear-gradient(135deg, ${T.hero1}, ${T.hero2})`,
          padding: "40px 20px 24px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: -40,
            right: -40,
            width: 160,
            height: 160,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.04)",
          }}
        />

        {/* Avatar with upload button */}
        <div
          style={{
            position: "relative",
            display: "inline-block",
            marginBottom: 12,
          }}
        >
          <div
            style={{
              width: 96,
              height: 96,
              borderRadius: 48,
              background: profile.avatar
                ? "transparent"
                : "rgba(255,255,255,0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgba(255,255,255,0.3)",
              overflow: "hidden",
            }}
          >
            {profile.avatar ? (
              <img
                src={profile.avatar}
                alt="avatar"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <Ic n="user" s={42} c="#fff" />
            )}
          </div>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleAvatarUpload}
            style={{ display: "none" }}
          />
          <button
            onClick={() => fileInputRef.current?.click()}
            style={{
              position: "absolute",
              bottom: -2,
              right: -2,
              background: T.accent,
              border: "3px solid #0A1628",
              borderRadius: 18,
              width: 32,
              height: 32,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Ic n="camera" s={14} c="#fff" />
          </button>
        </div>

        <div
          style={{
            fontSize: 20,
            fontWeight: 700,
            color: "#fff",
            marginBottom: 3,
          }}
        >
          {displayName}
        </div>
        <div
          style={{
            fontSize: 13,
            color: "rgba(255,255,255,0.6)",
            marginBottom: 16,
          }}
        >
          {profile.unit || "Air Force"}
        </div>

        {/* Ranking pills */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3,1fr)",
            gap: 8,
            position: "relative",
          }}
        >
          {[
            ["Local", userRanks.local, "pin"],
            ["Regional", userRanks.regional, "award"],
            ["Worldwide", userRanks.world, "globe"],
          ].map(([label, rank, icon]) => (
            <div
              key={label}
              style={{
                background: "rgba(255,255,255,0.10)",
                borderRadius: 12,
                padding: "10px 6px",
                textAlign: "center",
                border: "1px solid rgba(255,255,255,0.12)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 4,
                  marginBottom: 4,
                }}
              >
                <Ic n={icon} s={12} c="rgba(255,255,255,0.7)" />
                <span
                  style={{
                    fontSize: 9,
                    fontWeight: 700,
                    color: "rgba(255,255,255,0.7)",
                    letterSpacing: 0.4,
                    textTransform: "uppercase",
                  }}
                >
                  {label}
                </span>
              </div>
              <div
                style={{
                  fontSize: rank !== null && rank > 9999 ? 14 : 16,
                  fontWeight: 700,
                  color: "#fff",
                  lineHeight: 1,
                }}
              >
                {rank !== null ? `#${rank.toLocaleString()}` : "—"}
              </div>
            </div>
          ))}
        </div>
        {userRanks.local === null && (
          <div
            style={{
              marginTop: 10,
              fontSize: 11,
              color: "rgba(255,255,255,0.55)",
            }}
          >
            Save a PFRA score to see your rank
          </div>
        )}
      </div>
      <div style={{ padding: 16 }}>
        {profile.avatar && (
          <button
            onClick={removeAvatar}
            style={{
              width: "100%",
              background: `${T.danger}10`,
              border: `1px solid ${T.danger}30`,
              borderRadius: 12,
              padding: "10px 0",
              color: T.danger,
              fontSize: 12,
              fontWeight: 700,
              marginBottom: 14,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
            }}
          >
            <Ic n="trash" s={14} c={T.danger} />
            Remove Profile Photo
          </button>
        )}
        <div
          style={{
            background: isPro
              ? "#F0FDF4"
              : `linear-gradient(135deg, ${T.hero1}, ${T.hero2})`,
            border: isPro ? "1px solid #059A5E" : "none",
            borderRadius: 20,
            padding: 18,
            marginBottom: 18,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div
              style={{
                fontSize: 13,
                fontWeight: 700,
                color: isPro ? "#059A5E" : "rgba(255,255,255,0.7)",
                marginBottom: 2,
              }}
            >
              FORCEFIT {isPro ? "PRO" : "FREE"}
            </div>
            <div
              style={{
                fontSize: 15,
                fontWeight: 700,
                color: isPro ? "#059A5E" : "#fff",
              }}
            >
              {isPro ? "All features unlocked" : "Upgrade for full access"}
            </div>
          </div>
          {isPro ? (
            <Ic n="check" s={24} c="#059A5E" />
          ) : (
            <button
              onClick={() => setIsPro(true)}
              style={{
                background: "#fff",
                color: "#0A1628",
                borderRadius: 24,
                padding: "8px 20px",
                fontSize: 13,
                fontWeight: 700,
              }}
            >
              Go Pro
            </button>
          )}
        </div>
        <div
          style={{
            background: T.card,
            border: `1px solid ${T.border}`,
            borderRadius: 18,
            padding: 18,
            marginBottom: 16,
          }}
        >
          <div
            style={{
              fontSize: 15,
              fontWeight: 700,
              color: T.text,
              marginBottom: 14,
            }}
          >
            Personal Info
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 12,
              marginBottom: 12,
            }}
          >
            <div>
              <label style={lbl}>First Name</label>
              <input
                value={profile.name}
                onChange={(e) => upd("name", e.target.value)}
                style={inp}
                placeholder="Name"
              />
            </div>
            <div>
              <label style={lbl}>Rank</label>
              <select
                value={profile.rank}
                onChange={(e) => upd("rank", e.target.value)}
                style={inp}
              >
                <option value="">Select</option>
                {ranks.map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 12,
              marginBottom: 12,
            }}
          >
            <div>
              <label style={lbl}>Gender</label>
              <select
                value={profile.gender}
                onChange={(e) => upd("gender", e.target.value)}
                style={inp}
              >
                <option value="M">Male</option>
                <option value="F">Female</option>
              </select>
            </div>
            <div>
              <label style={lbl}>Age</label>
              <input
                type="number"
                value={profile.age}
                onChange={(e) => upd("age", e.target.value)}
                style={inp}
                placeholder="28"
              />
            </div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={lbl}>
              Unit{" "}
              <span style={{ fontWeight: 400, fontStyle: "italic" }}>
                (optional)
              </span>
            </label>
            <input
              value={profile.unit}
              onChange={(e) => upd("unit", e.target.value)}
              style={inp}
              placeholder="e.g. 1 SOCS / Hurlburt Field"
            />
          </div>
          <div>
            <label style={lbl}>Next PFRA Date</label>
            <input
              type="date"
              value={profile.pfraDate}
              onChange={(e) => upd("pfraDate", e.target.value)}
              style={inp}
            />
          </div>
        </div>
        <div
          style={{
            background: T.card,
            border: `1px solid ${T.border}`,
            borderRadius: 18,
            padding: 18,
            marginBottom: 16,
          }}
        >
          <div
            style={{
              fontSize: 15,
              fontWeight: 700,
              color: T.text,
              marginBottom: 14,
            }}
          >
            App Theme
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3,1fr)",
              gap: 10,
            }}
          >
            {[
              ["blue", "Air Force", "#1E4FD8"],
              ["black", "Tactical", "#C8A84B"],
              ["white", "Clean", "#374151"],
            ].map(([k, l, c]) => (
              <button
                key={k}
                onClick={() => setTheme(k)}
                style={{
                  background: theme === k ? `${c}15` : T.bg,
                  border: `2px solid ${theme === k ? c : T.border}`,
                  borderRadius: 14,
                  padding: "14px 8px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: 14,
                    background: c,
                    margin: "0 auto 8px",
                  }}
                />
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: theme === k ? c : T.textMuted,
                  }}
                >
                  {l}
                </div>
              </button>
            ))}
          </div>
        </div>
        <div
          style={{
            background: T.bg,
            border: `1px solid ${T.border}`,
            borderRadius: 14,
            padding: 14,
          }}
        >
          <div style={{ fontSize: 12, color: T.textMuted, lineHeight: 1.7 }}>
            FORCEFIT is an unofficial training aid. PFRA scoring reflects
            standards effective Mar 2026. Consult your unit Fitness Program
            Manager for official guidance.
          </div>
        </div>
      </div>
    </div>
  );
}
